/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** ISO8601 Date values */
  Date: any;
  /** BigInt value */
  GraphQLBigInt: any;
  /** A Float or a String */
  GraphQLStringOrFloat: any;
  /** Hashed string values */
  Hash: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type Mutation = {
  __typename?: 'Mutation';
  create_form_entries_item?: Maybe<Form_Entries>;
  create_form_entries_items: Array<Form_Entries>;
};


export type MutationCreate_Form_Entries_ItemArgs = {
  data: Create_Form_Entries_Input;
};


export type MutationCreate_Form_Entries_ItemsArgs = {
  data?: InputMaybe<Array<Create_Form_Entries_Input>>;
  filter?: InputMaybe<Form_Entries_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Query = {
  __typename?: 'Query';
  animals: Array<Animals>;
  animals_aggregated: Array<Animals_Aggregated>;
  animals_by_id?: Maybe<Animals>;
  animals_translations: Array<Animals_Translations>;
  animals_translations_aggregated: Array<Animals_Translations_Aggregated>;
  animals_translations_by_id?: Maybe<Animals_Translations>;
  animations: Array<Animations>;
  animations_aggregated: Array<Animations_Aggregated>;
  animations_by_id?: Maybe<Animations>;
  articles: Array<Articles>;
  articles_aggregated: Array<Articles_Aggregated>;
  articles_by_id?: Maybe<Articles>;
  articles_translations: Array<Articles_Translations>;
  articles_translations_aggregated: Array<Articles_Translations_Aggregated>;
  articles_translations_by_id?: Maybe<Articles_Translations>;
  block_content: Array<Block_Content>;
  block_content_aggregated: Array<Block_Content_Aggregated>;
  block_content_by_id?: Maybe<Block_Content>;
  block_contest: Array<Block_Contest>;
  block_contest_aggregated: Array<Block_Contest_Aggregated>;
  block_contest_by_id?: Maybe<Block_Contest>;
  block_faq: Array<Block_Faq>;
  block_faq_aggregated: Array<Block_Faq_Aggregated>;
  block_faq_by_id?: Maybe<Block_Faq>;
  block_mdx: Array<Block_Mdx>;
  block_mdx_aggregated: Array<Block_Mdx_Aggregated>;
  block_mdx_by_id?: Maybe<Block_Mdx>;
  block_stories: Array<Block_Stories>;
  block_stories_aggregated: Array<Block_Stories_Aggregated>;
  block_stories_by_id?: Maybe<Block_Stories>;
  block_stories_stories: Array<Block_Stories_Stories>;
  block_stories_stories_aggregated: Array<Block_Stories_Stories_Aggregated>;
  block_stories_stories_by_id?: Maybe<Block_Stories_Stories>;
  claims: Array<Claims>;
  claims_aggregated: Array<Claims_Aggregated>;
  claims_by_id?: Maybe<Claims>;
  claims_translations: Array<Claims_Translations>;
  claims_translations_aggregated: Array<Claims_Translations_Aggregated>;
  claims_translations_by_id?: Maybe<Claims_Translations>;
  color_schemes: Array<Color_Schemes>;
  color_schemes_aggregated: Array<Color_Schemes_Aggregated>;
  color_schemes_by_id?: Maybe<Color_Schemes>;
  form_entries: Array<Form_Entries>;
  form_entries_aggregated: Array<Form_Entries_Aggregated>;
  form_entries_by_id?: Maybe<Form_Entries>;
  forms: Array<Forms>;
  forms_aggregated: Array<Forms_Aggregated>;
  forms_by_id?: Maybe<Forms>;
  forms_translations: Array<Forms_Translations>;
  forms_translations_aggregated: Array<Forms_Translations_Aggregated>;
  forms_translations_by_id?: Maybe<Forms_Translations>;
  languages: Array<Languages>;
  languages_aggregated: Array<Languages_Aggregated>;
  languages_by_id?: Maybe<Languages>;
  navigation_items: Array<Navigation_Items>;
  navigation_items_aggregated: Array<Navigation_Items_Aggregated>;
  navigation_items_by_id?: Maybe<Navigation_Items>;
  navigations: Array<Navigations>;
  navigations_aggregated: Array<Navigations_Aggregated>;
  navigations_by_id?: Maybe<Navigations>;
  navigations_translations: Array<Navigations_Translations>;
  navigations_translations_aggregated: Array<Navigations_Translations_Aggregated>;
  navigations_translations_by_id?: Maybe<Navigations_Translations>;
  pages: Array<Pages>;
  pages_aggregated: Array<Pages_Aggregated>;
  pages_by_id?: Maybe<Pages>;
  pages_translations: Array<Pages_Translations>;
  pages_translations_aggregated: Array<Pages_Translations_Aggregated>;
  pages_translations_by_id?: Maybe<Pages_Translations>;
  pages_translations_sections: Array<Pages_Translations_Sections>;
  pages_translations_sections_aggregated: Array<Pages_Translations_Sections_Aggregated>;
  pages_translations_sections_by_id?: Maybe<Pages_Translations_Sections>;
  product_facets: Array<Product_Facets>;
  product_facets_aggregated: Array<Product_Facets_Aggregated>;
  product_facets_by_id?: Maybe<Product_Facets>;
  product_facets_item: Array<Product_Facets_Item>;
  product_facets_item_aggregated: Array<Product_Facets_Item_Aggregated>;
  product_facets_item_by_id?: Maybe<Product_Facets_Item>;
  product_facets_item_translations: Array<Product_Facets_Item_Translations>;
  product_facets_item_translations_aggregated: Array<Product_Facets_Item_Translations_Aggregated>;
  product_facets_item_translations_by_id?: Maybe<Product_Facets_Item_Translations>;
  product_facets_translations: Array<Product_Facets_Translations>;
  product_facets_translations_aggregated: Array<Product_Facets_Translations_Aggregated>;
  product_facets_translations_by_id?: Maybe<Product_Facets_Translations>;
  product_types: Array<Product_Types>;
  product_types_aggregated: Array<Product_Types_Aggregated>;
  product_types_by_id?: Maybe<Product_Types>;
  product_types_grid: Array<Product_Types_Grid>;
  product_types_grid_aggregated: Array<Product_Types_Grid_Aggregated>;
  product_types_grid_by_id?: Maybe<Product_Types_Grid>;
  product_types_product_facets: Array<Product_Types_Product_Facets>;
  product_types_product_facets_aggregated: Array<Product_Types_Product_Facets_Aggregated>;
  product_types_product_facets_by_id?: Maybe<Product_Types_Product_Facets>;
  product_types_translations: Array<Product_Types_Translations>;
  product_types_translations_aggregated: Array<Product_Types_Translations_Aggregated>;
  product_types_translations_by_id?: Maybe<Product_Types_Translations>;
  products: Array<Products>;
  products_aggregated: Array<Products_Aggregated>;
  products_animals: Array<Products_Animals>;
  products_animals_aggregated: Array<Products_Animals_Aggregated>;
  products_animals_by_id?: Maybe<Products_Animals>;
  products_by_id?: Maybe<Products>;
  products_claims: Array<Products_Claims>;
  products_claims_aggregated: Array<Products_Claims_Aggregated>;
  products_claims_by_id?: Maybe<Products_Claims>;
  products_files: Array<Products_Files>;
  products_files_1: Array<Products_Files_1>;
  products_files_1_aggregated: Array<Products_Files_1_Aggregated>;
  products_files_1_by_id?: Maybe<Products_Files_1>;
  products_files_aggregated: Array<Products_Files_Aggregated>;
  products_files_by_id?: Maybe<Products_Files>;
  products_product_facets_item: Array<Products_Product_Facets_Item>;
  products_product_facets_item_aggregated: Array<Products_Product_Facets_Item_Aggregated>;
  products_product_facets_item_by_id?: Maybe<Products_Product_Facets_Item>;
  products_products: Array<Products_Products>;
  products_products_aggregated: Array<Products_Products_Aggregated>;
  products_products_by_id?: Maybe<Products_Products>;
  products_translations: Array<Products_Translations>;
  products_translations_aggregated: Array<Products_Translations_Aggregated>;
  products_translations_by_id?: Maybe<Products_Translations>;
  products_translations_files: Array<Products_Translations_Files>;
  products_translations_files_aggregated: Array<Products_Translations_Files_Aggregated>;
  products_translations_files_by_id?: Maybe<Products_Translations_Files>;
  recommendations: Array<Recommendations>;
  recommendations_aggregated: Array<Recommendations_Aggregated>;
  recommendations_by_id?: Maybe<Recommendations>;
  recommendations_products: Array<Recommendations_Products>;
  recommendations_products_aggregated: Array<Recommendations_Products_Aggregated>;
  recommendations_products_by_id?: Maybe<Recommendations_Products>;
  seo: Array<Seo>;
  seo_aggregated: Array<Seo_Aggregated>;
  seo_by_id?: Maybe<Seo>;
  settings?: Maybe<Settings>;
  settings_translations: Array<Settings_Translations>;
  settings_translations_aggregated: Array<Settings_Translations_Aggregated>;
  settings_translations_by_id?: Maybe<Settings_Translations>;
  stories: Array<Stories>;
  stories_aggregated: Array<Stories_Aggregated>;
  stories_by_id?: Maybe<Stories>;
  videos: Array<Videos>;
  videos_aggregated: Array<Videos_Aggregated>;
  videos_by_id?: Maybe<Videos>;
  videos_translations: Array<Videos_Translations>;
  videos_translations_aggregated: Array<Videos_Translations_Aggregated>;
  videos_translations_by_id?: Maybe<Videos_Translations>;
};


export type QueryAnimalsArgs = {
  filter?: InputMaybe<Animals_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryAnimals_AggregatedArgs = {
  filter?: InputMaybe<Animals_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryAnimals_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryAnimals_TranslationsArgs = {
  filter?: InputMaybe<Animals_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryAnimals_Translations_AggregatedArgs = {
  filter?: InputMaybe<Animals_Translations_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryAnimals_Translations_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryAnimationsArgs = {
  filter?: InputMaybe<Animations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryAnimations_AggregatedArgs = {
  filter?: InputMaybe<Animations_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryAnimations_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryArticlesArgs = {
  filter?: InputMaybe<Articles_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryArticles_AggregatedArgs = {
  filter?: InputMaybe<Articles_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryArticles_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryArticles_TranslationsArgs = {
  filter?: InputMaybe<Articles_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryArticles_Translations_AggregatedArgs = {
  filter?: InputMaybe<Articles_Translations_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryArticles_Translations_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryBlock_ContentArgs = {
  filter?: InputMaybe<Block_Content_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryBlock_Content_AggregatedArgs = {
  filter?: InputMaybe<Block_Content_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryBlock_Content_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryBlock_ContestArgs = {
  filter?: InputMaybe<Block_Contest_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryBlock_Contest_AggregatedArgs = {
  filter?: InputMaybe<Block_Contest_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryBlock_Contest_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryBlock_FaqArgs = {
  filter?: InputMaybe<Block_Faq_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryBlock_Faq_AggregatedArgs = {
  filter?: InputMaybe<Block_Faq_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryBlock_Faq_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryBlock_MdxArgs = {
  filter?: InputMaybe<Block_Mdx_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryBlock_Mdx_AggregatedArgs = {
  filter?: InputMaybe<Block_Mdx_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryBlock_Mdx_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryBlock_StoriesArgs = {
  filter?: InputMaybe<Block_Stories_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryBlock_Stories_AggregatedArgs = {
  filter?: InputMaybe<Block_Stories_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryBlock_Stories_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryBlock_Stories_StoriesArgs = {
  filter?: InputMaybe<Block_Stories_Stories_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryBlock_Stories_Stories_AggregatedArgs = {
  filter?: InputMaybe<Block_Stories_Stories_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryBlock_Stories_Stories_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryClaimsArgs = {
  filter?: InputMaybe<Claims_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryClaims_AggregatedArgs = {
  filter?: InputMaybe<Claims_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryClaims_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryClaims_TranslationsArgs = {
  filter?: InputMaybe<Claims_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryClaims_Translations_AggregatedArgs = {
  filter?: InputMaybe<Claims_Translations_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryClaims_Translations_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryColor_SchemesArgs = {
  filter?: InputMaybe<Color_Schemes_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryColor_Schemes_AggregatedArgs = {
  filter?: InputMaybe<Color_Schemes_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryColor_Schemes_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryForm_EntriesArgs = {
  filter?: InputMaybe<Form_Entries_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryForm_Entries_AggregatedArgs = {
  filter?: InputMaybe<Form_Entries_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryForm_Entries_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryFormsArgs = {
  filter?: InputMaybe<Forms_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryForms_AggregatedArgs = {
  filter?: InputMaybe<Forms_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryForms_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryForms_TranslationsArgs = {
  filter?: InputMaybe<Forms_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryForms_Translations_AggregatedArgs = {
  filter?: InputMaybe<Forms_Translations_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryForms_Translations_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryLanguagesArgs = {
  filter?: InputMaybe<Languages_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryLanguages_AggregatedArgs = {
  filter?: InputMaybe<Languages_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryLanguages_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryNavigation_ItemsArgs = {
  filter?: InputMaybe<Navigation_Items_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryNavigation_Items_AggregatedArgs = {
  filter?: InputMaybe<Navigation_Items_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryNavigation_Items_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryNavigationsArgs = {
  filter?: InputMaybe<Navigations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryNavigations_AggregatedArgs = {
  filter?: InputMaybe<Navigations_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryNavigations_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryNavigations_TranslationsArgs = {
  filter?: InputMaybe<Navigations_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryNavigations_Translations_AggregatedArgs = {
  filter?: InputMaybe<Navigations_Translations_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryNavigations_Translations_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryPagesArgs = {
  filter?: InputMaybe<Pages_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryPages_AggregatedArgs = {
  filter?: InputMaybe<Pages_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryPages_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryPages_TranslationsArgs = {
  filter?: InputMaybe<Pages_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryPages_Translations_AggregatedArgs = {
  filter?: InputMaybe<Pages_Translations_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryPages_Translations_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryPages_Translations_SectionsArgs = {
  filter?: InputMaybe<Pages_Translations_Sections_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryPages_Translations_Sections_AggregatedArgs = {
  filter?: InputMaybe<Pages_Translations_Sections_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryPages_Translations_Sections_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryProduct_FacetsArgs = {
  filter?: InputMaybe<Product_Facets_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProduct_Facets_AggregatedArgs = {
  filter?: InputMaybe<Product_Facets_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProduct_Facets_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryProduct_Facets_ItemArgs = {
  filter?: InputMaybe<Product_Facets_Item_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProduct_Facets_Item_AggregatedArgs = {
  filter?: InputMaybe<Product_Facets_Item_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProduct_Facets_Item_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryProduct_Facets_Item_TranslationsArgs = {
  filter?: InputMaybe<Product_Facets_Item_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProduct_Facets_Item_Translations_AggregatedArgs = {
  filter?: InputMaybe<Product_Facets_Item_Translations_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProduct_Facets_Item_Translations_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryProduct_Facets_TranslationsArgs = {
  filter?: InputMaybe<Product_Facets_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProduct_Facets_Translations_AggregatedArgs = {
  filter?: InputMaybe<Product_Facets_Translations_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProduct_Facets_Translations_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryProduct_TypesArgs = {
  filter?: InputMaybe<Product_Types_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProduct_Types_AggregatedArgs = {
  filter?: InputMaybe<Product_Types_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProduct_Types_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryProduct_Types_GridArgs = {
  filter?: InputMaybe<Product_Types_Grid_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProduct_Types_Grid_AggregatedArgs = {
  filter?: InputMaybe<Product_Types_Grid_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProduct_Types_Grid_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryProduct_Types_Product_FacetsArgs = {
  filter?: InputMaybe<Product_Types_Product_Facets_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProduct_Types_Product_Facets_AggregatedArgs = {
  filter?: InputMaybe<Product_Types_Product_Facets_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProduct_Types_Product_Facets_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryProduct_Types_TranslationsArgs = {
  filter?: InputMaybe<Product_Types_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProduct_Types_Translations_AggregatedArgs = {
  filter?: InputMaybe<Product_Types_Translations_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProduct_Types_Translations_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryProductsArgs = {
  filter?: InputMaybe<Products_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProducts_AggregatedArgs = {
  filter?: InputMaybe<Products_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProducts_AnimalsArgs = {
  filter?: InputMaybe<Products_Animals_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProducts_Animals_AggregatedArgs = {
  filter?: InputMaybe<Products_Animals_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProducts_Animals_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryProducts_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryProducts_ClaimsArgs = {
  filter?: InputMaybe<Products_Claims_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProducts_Claims_AggregatedArgs = {
  filter?: InputMaybe<Products_Claims_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProducts_Claims_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryProducts_FilesArgs = {
  filter?: InputMaybe<Products_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProducts_Files_1Args = {
  filter?: InputMaybe<Products_Files_1_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProducts_Files_1_AggregatedArgs = {
  filter?: InputMaybe<Products_Files_1_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProducts_Files_1_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryProducts_Files_AggregatedArgs = {
  filter?: InputMaybe<Products_Files_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProducts_Files_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryProducts_Product_Facets_ItemArgs = {
  filter?: InputMaybe<Products_Product_Facets_Item_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProducts_Product_Facets_Item_AggregatedArgs = {
  filter?: InputMaybe<Products_Product_Facets_Item_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProducts_Product_Facets_Item_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryProducts_ProductsArgs = {
  filter?: InputMaybe<Products_Products_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProducts_Products_AggregatedArgs = {
  filter?: InputMaybe<Products_Products_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProducts_Products_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryProducts_TranslationsArgs = {
  filter?: InputMaybe<Products_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProducts_Translations_AggregatedArgs = {
  filter?: InputMaybe<Products_Translations_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProducts_Translations_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryProducts_Translations_FilesArgs = {
  filter?: InputMaybe<Products_Translations_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProducts_Translations_Files_AggregatedArgs = {
  filter?: InputMaybe<Products_Translations_Files_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProducts_Translations_Files_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryRecommendationsArgs = {
  filter?: InputMaybe<Recommendations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryRecommendations_AggregatedArgs = {
  filter?: InputMaybe<Recommendations_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryRecommendations_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryRecommendations_ProductsArgs = {
  filter?: InputMaybe<Recommendations_Products_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryRecommendations_Products_AggregatedArgs = {
  filter?: InputMaybe<Recommendations_Products_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryRecommendations_Products_By_IdArgs = {
  id: Scalars['ID'];
};


export type QuerySeoArgs = {
  filter?: InputMaybe<Seo_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QuerySeo_AggregatedArgs = {
  filter?: InputMaybe<Seo_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QuerySeo_By_IdArgs = {
  id: Scalars['ID'];
};


export type QuerySettings_TranslationsArgs = {
  filter?: InputMaybe<Settings_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QuerySettings_Translations_AggregatedArgs = {
  filter?: InputMaybe<Settings_Translations_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QuerySettings_Translations_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryStoriesArgs = {
  filter?: InputMaybe<Stories_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryStories_AggregatedArgs = {
  filter?: InputMaybe<Stories_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryStories_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryVideosArgs = {
  filter?: InputMaybe<Videos_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryVideos_AggregatedArgs = {
  filter?: InputMaybe<Videos_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryVideos_By_IdArgs = {
  id: Scalars['ID'];
};


export type QueryVideos_TranslationsArgs = {
  filter?: InputMaybe<Videos_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryVideos_Translations_AggregatedArgs = {
  filter?: InputMaybe<Videos_Translations_Filter>;
  groupBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryVideos_Translations_By_IdArgs = {
  id: Scalars['ID'];
};

export type Animals = {
  __typename?: 'animals';
  color?: Maybe<Scalars['String']>;
  color_scheme?: Maybe<Color_Schemes>;
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID'];
  products?: Maybe<Array<Maybe<Products>>>;
  products_func?: Maybe<Count_Functions>;
  seo?: Maybe<Seo>;
  translations?: Maybe<Array<Maybe<Animals_Translations>>>;
  translations_func?: Maybe<Count_Functions>;
  user_created?: Maybe<Directus_Users>;
  user_updated?: Maybe<Directus_Users>;
};


export type AnimalsColor_SchemeArgs = {
  filter?: InputMaybe<Color_Schemes_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type AnimalsProductsArgs = {
  filter?: InputMaybe<Products_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type AnimalsSeoArgs = {
  filter?: InputMaybe<Seo_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type AnimalsTranslationsArgs = {
  filter?: InputMaybe<Animals_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type AnimalsUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type AnimalsUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Animals_Aggregated = {
  __typename?: 'animals_aggregated';
  avg?: Maybe<Animals_Aggregated_Fields>;
  avgDistinct?: Maybe<Animals_Aggregated_Fields>;
  count?: Maybe<Animals_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Animals_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Animals_Aggregated_Fields>;
  min?: Maybe<Animals_Aggregated_Fields>;
  sum?: Maybe<Animals_Aggregated_Fields>;
  sumDistinct?: Maybe<Animals_Aggregated_Fields>;
};

export type Animals_Aggregated_Count = {
  __typename?: 'animals_aggregated_count';
  color?: Maybe<Scalars['Int']>;
  color_scheme?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  products?: Maybe<Scalars['Int']>;
  seo?: Maybe<Scalars['Int']>;
  translations?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
};

export type Animals_Aggregated_Fields = {
  __typename?: 'animals_aggregated_fields';
  color_scheme?: Maybe<Scalars['Float']>;
};

export type Animals_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Animals_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Animals_Filter>>>;
  color?: InputMaybe<String_Filter_Operators>;
  color_scheme?: InputMaybe<Color_Schemes_Filter>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  products?: InputMaybe<Products_Filter>;
  products_func?: InputMaybe<Count_Function_Filter_Operators>;
  seo?: InputMaybe<Seo_Filter>;
  translations?: InputMaybe<Animals_Translations_Filter>;
  translations_func?: InputMaybe<Count_Function_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type Animals_Translations = {
  __typename?: 'animals_translations';
  animals_id?: Maybe<Animals>;
  friendly_title?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  languages_code?: Maybe<Languages>;
  title?: Maybe<Scalars['String']>;
};


export type Animals_TranslationsAnimals_IdArgs = {
  filter?: InputMaybe<Animals_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Animals_TranslationsLanguages_CodeArgs = {
  filter?: InputMaybe<Languages_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Animals_Translations_Aggregated = {
  __typename?: 'animals_translations_aggregated';
  avg?: Maybe<Animals_Translations_Aggregated_Fields>;
  avgDistinct?: Maybe<Animals_Translations_Aggregated_Fields>;
  count?: Maybe<Animals_Translations_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Animals_Translations_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Animals_Translations_Aggregated_Fields>;
  min?: Maybe<Animals_Translations_Aggregated_Fields>;
  sum?: Maybe<Animals_Translations_Aggregated_Fields>;
  sumDistinct?: Maybe<Animals_Translations_Aggregated_Fields>;
};

export type Animals_Translations_Aggregated_Count = {
  __typename?: 'animals_translations_aggregated_count';
  animals_id?: Maybe<Scalars['Int']>;
  friendly_title?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  languages_code?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['Int']>;
};

export type Animals_Translations_Aggregated_Fields = {
  __typename?: 'animals_translations_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
};

export type Animals_Translations_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Animals_Translations_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Animals_Translations_Filter>>>;
  animals_id?: InputMaybe<Animals_Filter>;
  friendly_title?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<Number_Filter_Operators>;
  languages_code?: InputMaybe<Languages_Filter>;
  title?: InputMaybe<String_Filter_Operators>;
};

export type Animations = {
  __typename?: 'animations';
  animal?: Maybe<Animals>;
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID'];
  language?: Maybe<Languages>;
  lottie_file?: Maybe<Directus_Files>;
  preview?: Maybe<Directus_Files>;
  show_on_product_grid?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  user_created?: Maybe<Directus_Users>;
  user_updated?: Maybe<Directus_Users>;
};


export type AnimationsAnimalArgs = {
  filter?: InputMaybe<Animals_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type AnimationsLanguageArgs = {
  filter?: InputMaybe<Languages_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type AnimationsLottie_FileArgs = {
  filter?: InputMaybe<Directus_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type AnimationsPreviewArgs = {
  filter?: InputMaybe<Directus_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type AnimationsUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type AnimationsUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Animations_Aggregated = {
  __typename?: 'animations_aggregated';
  avg?: Maybe<Animations_Aggregated_Fields>;
  avgDistinct?: Maybe<Animations_Aggregated_Fields>;
  count?: Maybe<Animations_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Animations_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Animations_Aggregated_Fields>;
  min?: Maybe<Animations_Aggregated_Fields>;
  sum?: Maybe<Animations_Aggregated_Fields>;
  sumDistinct?: Maybe<Animations_Aggregated_Fields>;
};

export type Animations_Aggregated_Count = {
  __typename?: 'animations_aggregated_count';
  animal?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  language?: Maybe<Scalars['Int']>;
  lottie_file?: Maybe<Scalars['Int']>;
  preview?: Maybe<Scalars['Int']>;
  show_on_product_grid?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
};

export type Animations_Aggregated_Fields = {
  __typename?: 'animations_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

export type Animations_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Animations_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Animations_Filter>>>;
  animal?: InputMaybe<Animals_Filter>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<Number_Filter_Operators>;
  language?: InputMaybe<Languages_Filter>;
  lottie_file?: InputMaybe<Directus_Files_Filter>;
  preview?: InputMaybe<Directus_Files_Filter>;
  show_on_product_grid?: InputMaybe<Boolean_Filter_Operators>;
  sort?: InputMaybe<Number_Filter_Operators>;
  title?: InputMaybe<String_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type Articles = {
  __typename?: 'articles';
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  featured_image?: Maybe<Directus_Files>;
  id: Scalars['ID'];
  publication_date?: Maybe<Scalars['Date']>;
  publication_date_func?: Maybe<Datetime_Functions>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<Articles_Translations>>>;
  translations_func?: Maybe<Count_Functions>;
  user_created?: Maybe<Directus_Users>;
  user_updated?: Maybe<Directus_Users>;
};


export type ArticlesFeatured_ImageArgs = {
  filter?: InputMaybe<Directus_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ArticlesTranslationsArgs = {
  filter?: InputMaybe<Articles_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ArticlesUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ArticlesUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Articles_Aggregated = {
  __typename?: 'articles_aggregated';
  avg?: Maybe<Articles_Aggregated_Fields>;
  avgDistinct?: Maybe<Articles_Aggregated_Fields>;
  count?: Maybe<Articles_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Articles_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Articles_Aggregated_Fields>;
  min?: Maybe<Articles_Aggregated_Fields>;
  sum?: Maybe<Articles_Aggregated_Fields>;
  sumDistinct?: Maybe<Articles_Aggregated_Fields>;
};

export type Articles_Aggregated_Count = {
  __typename?: 'articles_aggregated_count';
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  featured_image?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  publication_date?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  translations?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
};

export type Articles_Aggregated_Fields = {
  __typename?: 'articles_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

export type Articles_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Articles_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Articles_Filter>>>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  featured_image?: InputMaybe<Directus_Files_Filter>;
  id?: InputMaybe<Number_Filter_Operators>;
  publication_date?: InputMaybe<Date_Filter_Operators>;
  publication_date_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  sort?: InputMaybe<Number_Filter_Operators>;
  status?: InputMaybe<String_Filter_Operators>;
  translations?: InputMaybe<Articles_Translations_Filter>;
  translations_func?: InputMaybe<Count_Function_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type Articles_Translations = {
  __typename?: 'articles_translations';
  articles_id?: Maybe<Articles>;
  content?: Maybe<Scalars['String']>;
  excerpt?: Maybe<Scalars['String']>;
  featured_image?: Maybe<Directus_Files>;
  id: Scalars['ID'];
  languages_code?: Maybe<Languages>;
  seo?: Maybe<Seo>;
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};


export type Articles_TranslationsArticles_IdArgs = {
  filter?: InputMaybe<Articles_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Articles_TranslationsFeatured_ImageArgs = {
  filter?: InputMaybe<Directus_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Articles_TranslationsLanguages_CodeArgs = {
  filter?: InputMaybe<Languages_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Articles_TranslationsSeoArgs = {
  filter?: InputMaybe<Seo_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Articles_Translations_Aggregated = {
  __typename?: 'articles_translations_aggregated';
  avg?: Maybe<Articles_Translations_Aggregated_Fields>;
  avgDistinct?: Maybe<Articles_Translations_Aggregated_Fields>;
  count?: Maybe<Articles_Translations_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Articles_Translations_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Articles_Translations_Aggregated_Fields>;
  min?: Maybe<Articles_Translations_Aggregated_Fields>;
  sum?: Maybe<Articles_Translations_Aggregated_Fields>;
  sumDistinct?: Maybe<Articles_Translations_Aggregated_Fields>;
};

export type Articles_Translations_Aggregated_Count = {
  __typename?: 'articles_translations_aggregated_count';
  articles_id?: Maybe<Scalars['Int']>;
  content?: Maybe<Scalars['Int']>;
  excerpt?: Maybe<Scalars['Int']>;
  featured_image?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  languages_code?: Maybe<Scalars['Int']>;
  seo?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['Int']>;
};

export type Articles_Translations_Aggregated_Fields = {
  __typename?: 'articles_translations_aggregated_fields';
  articles_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type Articles_Translations_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Articles_Translations_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Articles_Translations_Filter>>>;
  articles_id?: InputMaybe<Articles_Filter>;
  content?: InputMaybe<String_Filter_Operators>;
  excerpt?: InputMaybe<String_Filter_Operators>;
  featured_image?: InputMaybe<Directus_Files_Filter>;
  id?: InputMaybe<Number_Filter_Operators>;
  languages_code?: InputMaybe<Languages_Filter>;
  seo?: InputMaybe<Seo_Filter>;
  slug?: InputMaybe<String_Filter_Operators>;
  title?: InputMaybe<String_Filter_Operators>;
};

export type Block_Content = {
  __typename?: 'block_content';
  colors?: Maybe<Color_Schemes>;
  content?: Maybe<Scalars['String']>;
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  /** Can be used as the element ID or to apply condition in code */
  friendly_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Show as an anchor in the top bar */
  is_anchored?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Languages>;
  /** Value used to name the associated navigation anchor to the section */
  short_title?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  user_created?: Maybe<Directus_Users>;
  user_updated?: Maybe<Directus_Users>;
};


export type Block_ContentColorsArgs = {
  filter?: InputMaybe<Color_Schemes_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Block_ContentLanguageArgs = {
  filter?: InputMaybe<Languages_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Block_ContentUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Block_ContentUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Block_Content_Aggregated = {
  __typename?: 'block_content_aggregated';
  avg?: Maybe<Block_Content_Aggregated_Fields>;
  avgDistinct?: Maybe<Block_Content_Aggregated_Fields>;
  count?: Maybe<Block_Content_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Block_Content_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Block_Content_Aggregated_Fields>;
  min?: Maybe<Block_Content_Aggregated_Fields>;
  sum?: Maybe<Block_Content_Aggregated_Fields>;
  sumDistinct?: Maybe<Block_Content_Aggregated_Fields>;
};

export type Block_Content_Aggregated_Count = {
  __typename?: 'block_content_aggregated_count';
  colors?: Maybe<Scalars['Int']>;
  content?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  /** Can be used as the element ID or to apply condition in code */
  friendly_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  /** Show as an anchor in the top bar */
  is_anchored?: Maybe<Scalars['Int']>;
  language?: Maybe<Scalars['Int']>;
  /** Value used to name the associated navigation anchor to the section */
  short_title?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
};

export type Block_Content_Aggregated_Fields = {
  __typename?: 'block_content_aggregated_fields';
  colors?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

export type Block_Content_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Block_Content_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Block_Content_Filter>>>;
  colors?: InputMaybe<Color_Schemes_Filter>;
  content?: InputMaybe<String_Filter_Operators>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  friendly_id?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<Number_Filter_Operators>;
  is_anchored?: InputMaybe<Boolean_Filter_Operators>;
  language?: InputMaybe<Languages_Filter>;
  short_title?: InputMaybe<String_Filter_Operators>;
  sort?: InputMaybe<Number_Filter_Operators>;
  title?: InputMaybe<String_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type Block_Contest = {
  __typename?: 'block_contest';
  colors?: Maybe<Color_Schemes>;
  content?: Maybe<Scalars['String']>;
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  featured_image?: Maybe<Directus_Files>;
  friendly_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_anchored?: Maybe<Scalars['Boolean']>;
  short_title?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  user_created?: Maybe<Directus_Users>;
  user_updated?: Maybe<Directus_Users>;
};


export type Block_ContestColorsArgs = {
  filter?: InputMaybe<Color_Schemes_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Block_ContestFeatured_ImageArgs = {
  filter?: InputMaybe<Directus_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Block_ContestUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Block_ContestUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Block_Contest_Aggregated = {
  __typename?: 'block_contest_aggregated';
  avg?: Maybe<Block_Contest_Aggregated_Fields>;
  avgDistinct?: Maybe<Block_Contest_Aggregated_Fields>;
  count?: Maybe<Block_Contest_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Block_Contest_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Block_Contest_Aggregated_Fields>;
  min?: Maybe<Block_Contest_Aggregated_Fields>;
  sum?: Maybe<Block_Contest_Aggregated_Fields>;
  sumDistinct?: Maybe<Block_Contest_Aggregated_Fields>;
};

export type Block_Contest_Aggregated_Count = {
  __typename?: 'block_contest_aggregated_count';
  colors?: Maybe<Scalars['Int']>;
  content?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  featured_image?: Maybe<Scalars['Int']>;
  friendly_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_anchored?: Maybe<Scalars['Int']>;
  short_title?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
};

export type Block_Contest_Aggregated_Fields = {
  __typename?: 'block_contest_aggregated_fields';
  colors?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

export type Block_Contest_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Block_Contest_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Block_Contest_Filter>>>;
  colors?: InputMaybe<Color_Schemes_Filter>;
  content?: InputMaybe<String_Filter_Operators>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  featured_image?: InputMaybe<Directus_Files_Filter>;
  friendly_id?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<Number_Filter_Operators>;
  is_anchored?: InputMaybe<Boolean_Filter_Operators>;
  short_title?: InputMaybe<String_Filter_Operators>;
  sort?: InputMaybe<Number_Filter_Operators>;
  status?: InputMaybe<String_Filter_Operators>;
  title?: InputMaybe<String_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type Block_Faq = {
  __typename?: 'block_faq';
  colors?: Maybe<Color_Schemes>;
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID'];
  is_anchored?: Maybe<Scalars['Boolean']>;
  qna_list?: Maybe<Scalars['JSON']>;
  qna_list_func?: Maybe<Count_Functions>;
  /** Value used to name the associated navigation anchor to the section */
  short_title?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  user_created?: Maybe<Directus_Users>;
  user_updated?: Maybe<Directus_Users>;
};


export type Block_FaqColorsArgs = {
  filter?: InputMaybe<Color_Schemes_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Block_FaqUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Block_FaqUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Block_Faq_Aggregated = {
  __typename?: 'block_faq_aggregated';
  avg?: Maybe<Block_Faq_Aggregated_Fields>;
  avgDistinct?: Maybe<Block_Faq_Aggregated_Fields>;
  count?: Maybe<Block_Faq_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Block_Faq_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Block_Faq_Aggregated_Fields>;
  min?: Maybe<Block_Faq_Aggregated_Fields>;
  sum?: Maybe<Block_Faq_Aggregated_Fields>;
  sumDistinct?: Maybe<Block_Faq_Aggregated_Fields>;
};

export type Block_Faq_Aggregated_Count = {
  __typename?: 'block_faq_aggregated_count';
  colors?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_anchored?: Maybe<Scalars['Int']>;
  qna_list?: Maybe<Scalars['Int']>;
  /** Value used to name the associated navigation anchor to the section */
  short_title?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
};

export type Block_Faq_Aggregated_Fields = {
  __typename?: 'block_faq_aggregated_fields';
  colors?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

export type Block_Faq_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Block_Faq_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Block_Faq_Filter>>>;
  colors?: InputMaybe<Color_Schemes_Filter>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<Number_Filter_Operators>;
  is_anchored?: InputMaybe<Boolean_Filter_Operators>;
  qna_list?: InputMaybe<String_Filter_Operators>;
  qna_list_func?: InputMaybe<Count_Function_Filter_Operators>;
  short_title?: InputMaybe<String_Filter_Operators>;
  sort?: InputMaybe<Number_Filter_Operators>;
  status?: InputMaybe<String_Filter_Operators>;
  title?: InputMaybe<String_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type Block_Mdx = {
  __typename?: 'block_mdx';
  content?: Maybe<Scalars['String']>;
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  /** Can be used as the element ID or to apply condition in code */
  friendly_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_anchored?: Maybe<Scalars['Boolean']>;
  /** Value used to name the associated navigation anchor to the section */
  short_title?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  user_created?: Maybe<Directus_Users>;
  user_updated?: Maybe<Directus_Users>;
};


export type Block_MdxUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Block_MdxUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Block_Mdx_Aggregated = {
  __typename?: 'block_mdx_aggregated';
  avg?: Maybe<Block_Mdx_Aggregated_Fields>;
  avgDistinct?: Maybe<Block_Mdx_Aggregated_Fields>;
  count?: Maybe<Block_Mdx_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Block_Mdx_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Block_Mdx_Aggregated_Fields>;
  min?: Maybe<Block_Mdx_Aggregated_Fields>;
  sum?: Maybe<Block_Mdx_Aggregated_Fields>;
  sumDistinct?: Maybe<Block_Mdx_Aggregated_Fields>;
};

export type Block_Mdx_Aggregated_Count = {
  __typename?: 'block_mdx_aggregated_count';
  content?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  /** Can be used as the element ID or to apply condition in code */
  friendly_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_anchored?: Maybe<Scalars['Int']>;
  /** Value used to name the associated navigation anchor to the section */
  short_title?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
};

export type Block_Mdx_Aggregated_Fields = {
  __typename?: 'block_mdx_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

export type Block_Mdx_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Block_Mdx_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Block_Mdx_Filter>>>;
  content?: InputMaybe<String_Filter_Operators>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  friendly_id?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<Number_Filter_Operators>;
  is_anchored?: InputMaybe<Boolean_Filter_Operators>;
  short_title?: InputMaybe<String_Filter_Operators>;
  sort?: InputMaybe<Number_Filter_Operators>;
  status?: InputMaybe<String_Filter_Operators>;
  title?: InputMaybe<String_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type Block_Stories = {
  __typename?: 'block_stories';
  colors?: Maybe<Color_Schemes>;
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  friendly_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_anchored?: Maybe<Scalars['Boolean']>;
  /** Value used to name the associated navigation anchor to the section */
  short_title?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  stories?: Maybe<Array<Maybe<Block_Stories_Stories>>>;
  stories_func?: Maybe<Count_Functions>;
  title?: Maybe<Scalars['String']>;
  user_created?: Maybe<Directus_Users>;
  user_updated?: Maybe<Directus_Users>;
};


export type Block_StoriesColorsArgs = {
  filter?: InputMaybe<Color_Schemes_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Block_StoriesStoriesArgs = {
  filter?: InputMaybe<Block_Stories_Stories_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Block_StoriesUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Block_StoriesUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Block_Stories_Aggregated = {
  __typename?: 'block_stories_aggregated';
  avg?: Maybe<Block_Stories_Aggregated_Fields>;
  avgDistinct?: Maybe<Block_Stories_Aggregated_Fields>;
  count?: Maybe<Block_Stories_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Block_Stories_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Block_Stories_Aggregated_Fields>;
  min?: Maybe<Block_Stories_Aggregated_Fields>;
  sum?: Maybe<Block_Stories_Aggregated_Fields>;
  sumDistinct?: Maybe<Block_Stories_Aggregated_Fields>;
};

export type Block_Stories_Aggregated_Count = {
  __typename?: 'block_stories_aggregated_count';
  colors?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  friendly_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  is_anchored?: Maybe<Scalars['Int']>;
  /** Value used to name the associated navigation anchor to the section */
  short_title?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  stories?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
};

export type Block_Stories_Aggregated_Fields = {
  __typename?: 'block_stories_aggregated_fields';
  colors?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

export type Block_Stories_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Block_Stories_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Block_Stories_Filter>>>;
  colors?: InputMaybe<Color_Schemes_Filter>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  friendly_id?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<Number_Filter_Operators>;
  is_anchored?: InputMaybe<Boolean_Filter_Operators>;
  short_title?: InputMaybe<String_Filter_Operators>;
  sort?: InputMaybe<Number_Filter_Operators>;
  status?: InputMaybe<String_Filter_Operators>;
  stories?: InputMaybe<Block_Stories_Stories_Filter>;
  stories_func?: InputMaybe<Count_Function_Filter_Operators>;
  title?: InputMaybe<String_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type Block_Stories_Stories = {
  __typename?: 'block_stories_stories';
  block_stories_id?: Maybe<Block_Stories>;
  id: Scalars['ID'];
  stories_id?: Maybe<Stories>;
};


export type Block_Stories_StoriesBlock_Stories_IdArgs = {
  filter?: InputMaybe<Block_Stories_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Block_Stories_StoriesStories_IdArgs = {
  filter?: InputMaybe<Stories_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Block_Stories_Stories_Aggregated = {
  __typename?: 'block_stories_stories_aggregated';
  avg?: Maybe<Block_Stories_Stories_Aggregated_Fields>;
  avgDistinct?: Maybe<Block_Stories_Stories_Aggregated_Fields>;
  count?: Maybe<Block_Stories_Stories_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Block_Stories_Stories_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Block_Stories_Stories_Aggregated_Fields>;
  min?: Maybe<Block_Stories_Stories_Aggregated_Fields>;
  sum?: Maybe<Block_Stories_Stories_Aggregated_Fields>;
  sumDistinct?: Maybe<Block_Stories_Stories_Aggregated_Fields>;
};

export type Block_Stories_Stories_Aggregated_Count = {
  __typename?: 'block_stories_stories_aggregated_count';
  block_stories_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  stories_id?: Maybe<Scalars['Int']>;
};

export type Block_Stories_Stories_Aggregated_Fields = {
  __typename?: 'block_stories_stories_aggregated_fields';
  block_stories_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type Block_Stories_Stories_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Block_Stories_Stories_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Block_Stories_Stories_Filter>>>;
  block_stories_id?: InputMaybe<Block_Stories_Filter>;
  id?: InputMaybe<Number_Filter_Operators>;
  stories_id?: InputMaybe<Stories_Filter>;
};

export type Boolean_Filter_Operators = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nnull?: InputMaybe<Scalars['Boolean']>;
  _null?: InputMaybe<Scalars['Boolean']>;
};

export type Claims = {
  __typename?: 'claims';
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  icon?: Maybe<Directus_Files>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  translations?: Maybe<Array<Maybe<Claims_Translations>>>;
  translations_func?: Maybe<Count_Functions>;
  user_created?: Maybe<Directus_Users>;
  user_updated?: Maybe<Directus_Users>;
};


export type ClaimsIconArgs = {
  filter?: InputMaybe<Directus_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ClaimsTranslationsArgs = {
  filter?: InputMaybe<Claims_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ClaimsUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ClaimsUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Claims_Aggregated = {
  __typename?: 'claims_aggregated';
  avg?: Maybe<Claims_Aggregated_Fields>;
  avgDistinct?: Maybe<Claims_Aggregated_Fields>;
  count?: Maybe<Claims_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Claims_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Claims_Aggregated_Fields>;
  min?: Maybe<Claims_Aggregated_Fields>;
  sum?: Maybe<Claims_Aggregated_Fields>;
  sumDistinct?: Maybe<Claims_Aggregated_Fields>;
};

export type Claims_Aggregated_Count = {
  __typename?: 'claims_aggregated_count';
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  icon?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  translations?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
};

export type Claims_Aggregated_Fields = {
  __typename?: 'claims_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

export type Claims_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Claims_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Claims_Filter>>>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  icon?: InputMaybe<Directus_Files_Filter>;
  id?: InputMaybe<Number_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  sort?: InputMaybe<Number_Filter_Operators>;
  translations?: InputMaybe<Claims_Translations_Filter>;
  translations_func?: InputMaybe<Count_Function_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type Claims_Translations = {
  __typename?: 'claims_translations';
  claims_id?: Maybe<Claims>;
  content?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  languages_code?: Maybe<Languages>;
};


export type Claims_TranslationsClaims_IdArgs = {
  filter?: InputMaybe<Claims_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Claims_TranslationsLanguages_CodeArgs = {
  filter?: InputMaybe<Languages_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Claims_Translations_Aggregated = {
  __typename?: 'claims_translations_aggregated';
  avg?: Maybe<Claims_Translations_Aggregated_Fields>;
  avgDistinct?: Maybe<Claims_Translations_Aggregated_Fields>;
  count?: Maybe<Claims_Translations_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Claims_Translations_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Claims_Translations_Aggregated_Fields>;
  min?: Maybe<Claims_Translations_Aggregated_Fields>;
  sum?: Maybe<Claims_Translations_Aggregated_Fields>;
  sumDistinct?: Maybe<Claims_Translations_Aggregated_Fields>;
};

export type Claims_Translations_Aggregated_Count = {
  __typename?: 'claims_translations_aggregated_count';
  claims_id?: Maybe<Scalars['Int']>;
  content?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  languages_code?: Maybe<Scalars['Int']>;
};

export type Claims_Translations_Aggregated_Fields = {
  __typename?: 'claims_translations_aggregated_fields';
  claims_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
};

export type Claims_Translations_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Claims_Translations_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Claims_Translations_Filter>>>;
  claims_id?: InputMaybe<Claims_Filter>;
  content?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<Number_Filter_Operators>;
  languages_code?: InputMaybe<Languages_Filter>;
};

export type Color_Schemes = {
  __typename?: 'color_schemes';
  /** Color used in the logo */
  accent?: Maybe<Scalars['String']>;
  accent_muted?: Maybe<Scalars['String']>;
  background?: Maybe<Scalars['String']>;
  background_muted?: Maybe<Scalars['String']>;
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID'];
  outline?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  user_created?: Maybe<Directus_Users>;
  user_updated?: Maybe<Directus_Users>;
};


export type Color_SchemesUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Color_SchemesUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Color_Schemes_Aggregated = {
  __typename?: 'color_schemes_aggregated';
  avg?: Maybe<Color_Schemes_Aggregated_Fields>;
  avgDistinct?: Maybe<Color_Schemes_Aggregated_Fields>;
  count?: Maybe<Color_Schemes_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Color_Schemes_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Color_Schemes_Aggregated_Fields>;
  min?: Maybe<Color_Schemes_Aggregated_Fields>;
  sum?: Maybe<Color_Schemes_Aggregated_Fields>;
  sumDistinct?: Maybe<Color_Schemes_Aggregated_Fields>;
};

export type Color_Schemes_Aggregated_Count = {
  __typename?: 'color_schemes_aggregated_count';
  /** Color used in the logo */
  accent?: Maybe<Scalars['Int']>;
  accent_muted?: Maybe<Scalars['Int']>;
  background?: Maybe<Scalars['Int']>;
  background_muted?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  outline?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
};

export type Color_Schemes_Aggregated_Fields = {
  __typename?: 'color_schemes_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
};

export type Color_Schemes_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Color_Schemes_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Color_Schemes_Filter>>>;
  accent?: InputMaybe<String_Filter_Operators>;
  accent_muted?: InputMaybe<String_Filter_Operators>;
  background?: InputMaybe<String_Filter_Operators>;
  background_muted?: InputMaybe<String_Filter_Operators>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<Number_Filter_Operators>;
  outline?: InputMaybe<String_Filter_Operators>;
  title?: InputMaybe<String_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type Count_Function_Filter_Operators = {
  count?: InputMaybe<Number_Filter_Operators>;
};

export type Count_Functions = {
  __typename?: 'count_functions';
  count?: Maybe<Scalars['Int']>;
};

export type Create_Form_Entries_Input = {
  content: Scalars['JSON'];
  date_created?: InputMaybe<Scalars['Date']>;
  date_updated?: InputMaybe<Scalars['Date']>;
  form?: InputMaybe<Scalars['String']>;
  from_email?: InputMaybe<Scalars['String']>;
  from_ip?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  language?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  user_created?: InputMaybe<Scalars['String']>;
  user_updated?: InputMaybe<Scalars['String']>;
};

export type Date_Filter_Operators = {
  _between?: InputMaybe<Array<InputMaybe<Scalars['GraphQLStringOrFloat']>>>;
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _nbetween?: InputMaybe<Array<InputMaybe<Scalars['GraphQLStringOrFloat']>>>;
  _neq?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  _nnull?: InputMaybe<Scalars['Boolean']>;
  _null?: InputMaybe<Scalars['Boolean']>;
};

export type Datetime_Function_Filter_Operators = {
  day?: InputMaybe<Number_Filter_Operators>;
  hour?: InputMaybe<Number_Filter_Operators>;
  minute?: InputMaybe<Number_Filter_Operators>;
  month?: InputMaybe<Number_Filter_Operators>;
  second?: InputMaybe<Number_Filter_Operators>;
  week?: InputMaybe<Number_Filter_Operators>;
  weekday?: InputMaybe<Number_Filter_Operators>;
  year?: InputMaybe<Number_Filter_Operators>;
};

export type Datetime_Functions = {
  __typename?: 'datetime_functions';
  day?: Maybe<Scalars['Int']>;
  hour?: Maybe<Scalars['Int']>;
  minute?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  second?: Maybe<Scalars['Int']>;
  week?: Maybe<Scalars['Int']>;
  weekday?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type Directus_Files = {
  __typename?: 'directus_files';
  charset?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  embed?: Maybe<Scalars['String']>;
  filename_disk?: Maybe<Scalars['String']>;
  filename_download: Scalars['String'];
  filesize?: Maybe<Scalars['GraphQLBigInt']>;
  folder?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  location?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  metadata_func?: Maybe<Count_Functions>;
  modified_by?: Maybe<Directus_Users>;
  modified_on?: Maybe<Scalars['Date']>;
  modified_on_func?: Maybe<Datetime_Functions>;
  storage: Scalars['String'];
  tags?: Maybe<Scalars['JSON']>;
  tags_func?: Maybe<Count_Functions>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  uploaded_by?: Maybe<Directus_Users>;
  uploaded_on?: Maybe<Scalars['Date']>;
  uploaded_on_func?: Maybe<Datetime_Functions>;
  width?: Maybe<Scalars['Int']>;
};


export type Directus_FilesModified_ByArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Directus_FilesUploaded_ByArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Directus_Files_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Directus_Files_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Directus_Files_Filter>>>;
  charset?: InputMaybe<String_Filter_Operators>;
  description?: InputMaybe<String_Filter_Operators>;
  duration?: InputMaybe<Number_Filter_Operators>;
  embed?: InputMaybe<String_Filter_Operators>;
  filename_disk?: InputMaybe<String_Filter_Operators>;
  filename_download?: InputMaybe<String_Filter_Operators>;
  filesize?: InputMaybe<Number_Filter_Operators>;
  folder?: InputMaybe<String_Filter_Operators>;
  height?: InputMaybe<Number_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  location?: InputMaybe<String_Filter_Operators>;
  metadata?: InputMaybe<String_Filter_Operators>;
  metadata_func?: InputMaybe<Count_Function_Filter_Operators>;
  modified_by?: InputMaybe<Directus_Users_Filter>;
  modified_on?: InputMaybe<Date_Filter_Operators>;
  modified_on_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  storage?: InputMaybe<String_Filter_Operators>;
  tags?: InputMaybe<String_Filter_Operators>;
  tags_func?: InputMaybe<Count_Function_Filter_Operators>;
  title?: InputMaybe<String_Filter_Operators>;
  type?: InputMaybe<String_Filter_Operators>;
  uploaded_by?: InputMaybe<Directus_Users_Filter>;
  uploaded_on?: InputMaybe<Date_Filter_Operators>;
  uploaded_on_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  width?: InputMaybe<Number_Filter_Operators>;
};

export type Directus_Roles = {
  __typename?: 'directus_roles';
  admin_access: Scalars['Boolean'];
  app_access?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  enforce_tfa: Scalars['Boolean'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  ip_access?: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Scalars['String'];
  users?: Maybe<Array<Maybe<Directus_Users>>>;
  users_func?: Maybe<Count_Functions>;
};


export type Directus_RolesUsersArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Directus_Roles_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Directus_Roles_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Directus_Roles_Filter>>>;
  admin_access?: InputMaybe<Boolean_Filter_Operators>;
  app_access?: InputMaybe<Boolean_Filter_Operators>;
  description?: InputMaybe<String_Filter_Operators>;
  enforce_tfa?: InputMaybe<Boolean_Filter_Operators>;
  icon?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  ip_access?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
  users?: InputMaybe<Directus_Users_Filter>;
  users_func?: InputMaybe<Count_Function_Filter_Operators>;
};

export type Directus_Users = {
  __typename?: 'directus_users';
  avatar?: Maybe<Directus_Files>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  language?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  last_page?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['Hash']>;
  role?: Maybe<Directus_Roles>;
  status?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['JSON']>;
  tags_func?: Maybe<Count_Functions>;
  tfa_secret?: Maybe<Scalars['Hash']>;
  theme?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};


export type Directus_UsersAvatarArgs = {
  filter?: InputMaybe<Directus_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Directus_UsersRoleArgs = {
  filter?: InputMaybe<Directus_Roles_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Directus_Users_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Directus_Users_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Directus_Users_Filter>>>;
  avatar?: InputMaybe<Directus_Files_Filter>;
  description?: InputMaybe<String_Filter_Operators>;
  email?: InputMaybe<String_Filter_Operators>;
  first_name?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  language?: InputMaybe<String_Filter_Operators>;
  last_name?: InputMaybe<String_Filter_Operators>;
  last_page?: InputMaybe<String_Filter_Operators>;
  location?: InputMaybe<String_Filter_Operators>;
  password?: InputMaybe<Hash_Filter_Operators>;
  role?: InputMaybe<Directus_Roles_Filter>;
  status?: InputMaybe<String_Filter_Operators>;
  tags?: InputMaybe<String_Filter_Operators>;
  tags_func?: InputMaybe<Count_Function_Filter_Operators>;
  tfa_secret?: InputMaybe<Hash_Filter_Operators>;
  theme?: InputMaybe<String_Filter_Operators>;
  title?: InputMaybe<String_Filter_Operators>;
};

export type Form_Entries = {
  __typename?: 'form_entries';
  content: Scalars['JSON'];
  content_func?: Maybe<Count_Functions>;
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  form?: Maybe<Forms>;
  from_email?: Maybe<Scalars['String']>;
  from_ip?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  language?: Maybe<Languages>;
  status?: Maybe<Scalars['String']>;
  user_created?: Maybe<Directus_Users>;
  user_updated?: Maybe<Directus_Users>;
};


export type Form_EntriesFormArgs = {
  filter?: InputMaybe<Forms_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Form_EntriesLanguageArgs = {
  filter?: InputMaybe<Languages_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Form_EntriesUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Form_EntriesUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Form_Entries_Aggregated = {
  __typename?: 'form_entries_aggregated';
  count?: Maybe<Form_Entries_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Form_Entries_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
};

export type Form_Entries_Aggregated_Count = {
  __typename?: 'form_entries_aggregated_count';
  content?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  form?: Maybe<Scalars['Int']>;
  from_email?: Maybe<Scalars['Int']>;
  from_ip?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  language?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
};

export type Form_Entries_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Form_Entries_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Form_Entries_Filter>>>;
  content?: InputMaybe<String_Filter_Operators>;
  content_func?: InputMaybe<Count_Function_Filter_Operators>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  form?: InputMaybe<Forms_Filter>;
  from_email?: InputMaybe<String_Filter_Operators>;
  from_ip?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  language?: InputMaybe<Languages_Filter>;
  status?: InputMaybe<String_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type Forms = {
  __typename?: 'forms';
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID'];
  status?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<Forms_Translations>>>;
  translations_func?: Maybe<Count_Functions>;
  user_created?: Maybe<Directus_Users>;
  user_updated?: Maybe<Directus_Users>;
};


export type FormsTranslationsArgs = {
  filter?: InputMaybe<Forms_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type FormsUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type FormsUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Forms_Aggregated = {
  __typename?: 'forms_aggregated';
  count?: Maybe<Forms_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Forms_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
};

export type Forms_Aggregated_Count = {
  __typename?: 'forms_aggregated_count';
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  translations?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
};

export type Forms_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Forms_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Forms_Filter>>>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  status?: InputMaybe<String_Filter_Operators>;
  translations?: InputMaybe<Forms_Translations_Filter>;
  translations_func?: InputMaybe<Count_Function_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type Forms_Translations = {
  __typename?: 'forms_translations';
  confirmation_msg?: Maybe<Scalars['String']>;
  forms_id?: Maybe<Forms>;
  id: Scalars['ID'];
  languages_code?: Maybe<Languages>;
  title?: Maybe<Scalars['String']>;
};


export type Forms_TranslationsForms_IdArgs = {
  filter?: InputMaybe<Forms_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Forms_TranslationsLanguages_CodeArgs = {
  filter?: InputMaybe<Languages_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Forms_Translations_Aggregated = {
  __typename?: 'forms_translations_aggregated';
  avg?: Maybe<Forms_Translations_Aggregated_Fields>;
  avgDistinct?: Maybe<Forms_Translations_Aggregated_Fields>;
  count?: Maybe<Forms_Translations_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Forms_Translations_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Forms_Translations_Aggregated_Fields>;
  min?: Maybe<Forms_Translations_Aggregated_Fields>;
  sum?: Maybe<Forms_Translations_Aggregated_Fields>;
  sumDistinct?: Maybe<Forms_Translations_Aggregated_Fields>;
};

export type Forms_Translations_Aggregated_Count = {
  __typename?: 'forms_translations_aggregated_count';
  confirmation_msg?: Maybe<Scalars['Int']>;
  forms_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  languages_code?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['Int']>;
};

export type Forms_Translations_Aggregated_Fields = {
  __typename?: 'forms_translations_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
};

export type Forms_Translations_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Forms_Translations_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Forms_Translations_Filter>>>;
  confirmation_msg?: InputMaybe<String_Filter_Operators>;
  forms_id?: InputMaybe<Forms_Filter>;
  id?: InputMaybe<Number_Filter_Operators>;
  languages_code?: InputMaybe<Languages_Filter>;
  title?: InputMaybe<String_Filter_Operators>;
};

export type Hash_Filter_Operators = {
  _empty?: InputMaybe<Scalars['Boolean']>;
  _nempty?: InputMaybe<Scalars['Boolean']>;
  _nnull?: InputMaybe<Scalars['Boolean']>;
  _null?: InputMaybe<Scalars['Boolean']>;
};

export type Languages = {
  __typename?: 'languages';
  code: Scalars['ID'];
  direction?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Languages_Aggregated = {
  __typename?: 'languages_aggregated';
  count?: Maybe<Languages_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Languages_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
};

export type Languages_Aggregated_Count = {
  __typename?: 'languages_aggregated_count';
  code?: Maybe<Scalars['Int']>;
  direction?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
};

export type Languages_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Languages_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Languages_Filter>>>;
  code?: InputMaybe<String_Filter_Operators>;
  direction?: InputMaybe<String_Filter_Operators>;
  name?: InputMaybe<String_Filter_Operators>;
};

export type Navigation_Items = {
  __typename?: 'navigation_items';
  children?: Maybe<Array<Maybe<Navigation_Items>>>;
  children_func?: Maybe<Count_Functions>;
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  has_children: Scalars['Boolean'];
  id: Scalars['ID'];
  navigation?: Maybe<Navigations_Translations>;
  page?: Maybe<Pages>;
  parent?: Maybe<Navigation_Items>;
  path?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
  target?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  user_created?: Maybe<Directus_Users>;
  user_updated?: Maybe<Directus_Users>;
};


export type Navigation_ItemsChildrenArgs = {
  filter?: InputMaybe<Navigation_Items_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Navigation_ItemsNavigationArgs = {
  filter?: InputMaybe<Navigations_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Navigation_ItemsPageArgs = {
  filter?: InputMaybe<Pages_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Navigation_ItemsParentArgs = {
  filter?: InputMaybe<Navigation_Items_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Navigation_ItemsUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Navigation_ItemsUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Navigation_Items_Aggregated = {
  __typename?: 'navigation_items_aggregated';
  avg?: Maybe<Navigation_Items_Aggregated_Fields>;
  avgDistinct?: Maybe<Navigation_Items_Aggregated_Fields>;
  count?: Maybe<Navigation_Items_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Navigation_Items_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Navigation_Items_Aggregated_Fields>;
  min?: Maybe<Navigation_Items_Aggregated_Fields>;
  sum?: Maybe<Navigation_Items_Aggregated_Fields>;
  sumDistinct?: Maybe<Navigation_Items_Aggregated_Fields>;
};

export type Navigation_Items_Aggregated_Count = {
  __typename?: 'navigation_items_aggregated_count';
  children?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  has_children?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  navigation?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  parent?: Maybe<Scalars['Int']>;
  path?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  target?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
};

export type Navigation_Items_Aggregated_Fields = {
  __typename?: 'navigation_items_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  navigation?: Maybe<Scalars['Float']>;
  page?: Maybe<Scalars['Float']>;
  parent?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

export type Navigation_Items_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Navigation_Items_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Navigation_Items_Filter>>>;
  children?: InputMaybe<Navigation_Items_Filter>;
  children_func?: InputMaybe<Count_Function_Filter_Operators>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  has_children?: InputMaybe<Boolean_Filter_Operators>;
  id?: InputMaybe<Number_Filter_Operators>;
  navigation?: InputMaybe<Navigations_Translations_Filter>;
  page?: InputMaybe<Pages_Filter>;
  parent?: InputMaybe<Navigation_Items_Filter>;
  path?: InputMaybe<String_Filter_Operators>;
  sort?: InputMaybe<Number_Filter_Operators>;
  target?: InputMaybe<String_Filter_Operators>;
  title?: InputMaybe<String_Filter_Operators>;
  type?: InputMaybe<String_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type Navigations = {
  __typename?: 'navigations';
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID'];
  location?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<Navigations_Translations>>>;
  translations_func?: Maybe<Count_Functions>;
  user_created?: Maybe<Directus_Users>;
  user_updated?: Maybe<Directus_Users>;
};


export type NavigationsTranslationsArgs = {
  filter?: InputMaybe<Navigations_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type NavigationsUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type NavigationsUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Navigations_Aggregated = {
  __typename?: 'navigations_aggregated';
  avg?: Maybe<Navigations_Aggregated_Fields>;
  avgDistinct?: Maybe<Navigations_Aggregated_Fields>;
  count?: Maybe<Navigations_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Navigations_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Navigations_Aggregated_Fields>;
  min?: Maybe<Navigations_Aggregated_Fields>;
  sum?: Maybe<Navigations_Aggregated_Fields>;
  sumDistinct?: Maybe<Navigations_Aggregated_Fields>;
};

export type Navigations_Aggregated_Count = {
  __typename?: 'navigations_aggregated_count';
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  location?: Maybe<Scalars['Int']>;
  translations?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
};

export type Navigations_Aggregated_Fields = {
  __typename?: 'navigations_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
};

export type Navigations_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Navigations_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Navigations_Filter>>>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<Number_Filter_Operators>;
  location?: InputMaybe<String_Filter_Operators>;
  translations?: InputMaybe<Navigations_Translations_Filter>;
  translations_func?: InputMaybe<Count_Function_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type Navigations_Translations = {
  __typename?: 'navigations_translations';
  id: Scalars['ID'];
  items?: Maybe<Array<Maybe<Navigation_Items>>>;
  items_func?: Maybe<Count_Functions>;
  languages_code?: Maybe<Languages>;
  navigations_id?: Maybe<Navigations>;
};


export type Navigations_TranslationsItemsArgs = {
  filter?: InputMaybe<Navigation_Items_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Navigations_TranslationsLanguages_CodeArgs = {
  filter?: InputMaybe<Languages_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Navigations_TranslationsNavigations_IdArgs = {
  filter?: InputMaybe<Navigations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Navigations_Translations_Aggregated = {
  __typename?: 'navigations_translations_aggregated';
  avg?: Maybe<Navigations_Translations_Aggregated_Fields>;
  avgDistinct?: Maybe<Navigations_Translations_Aggregated_Fields>;
  count?: Maybe<Navigations_Translations_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Navigations_Translations_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Navigations_Translations_Aggregated_Fields>;
  min?: Maybe<Navigations_Translations_Aggregated_Fields>;
  sum?: Maybe<Navigations_Translations_Aggregated_Fields>;
  sumDistinct?: Maybe<Navigations_Translations_Aggregated_Fields>;
};

export type Navigations_Translations_Aggregated_Count = {
  __typename?: 'navigations_translations_aggregated_count';
  id?: Maybe<Scalars['Int']>;
  items?: Maybe<Scalars['Int']>;
  languages_code?: Maybe<Scalars['Int']>;
  navigations_id?: Maybe<Scalars['Int']>;
};

export type Navigations_Translations_Aggregated_Fields = {
  __typename?: 'navigations_translations_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  navigations_id?: Maybe<Scalars['Float']>;
};

export type Navigations_Translations_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Navigations_Translations_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Navigations_Translations_Filter>>>;
  id?: InputMaybe<Number_Filter_Operators>;
  items?: InputMaybe<Navigation_Items_Filter>;
  items_func?: InputMaybe<Count_Function_Filter_Operators>;
  languages_code?: InputMaybe<Languages_Filter>;
  navigations_id?: InputMaybe<Navigations_Filter>;
};

export type Number_Filter_Operators = {
  _between?: InputMaybe<Array<InputMaybe<Scalars['GraphQLStringOrFloat']>>>;
  _eq?: InputMaybe<Scalars['GraphQLStringOrFloat']>;
  _gt?: InputMaybe<Scalars['GraphQLStringOrFloat']>;
  _gte?: InputMaybe<Scalars['GraphQLStringOrFloat']>;
  _in?: InputMaybe<Array<InputMaybe<Scalars['GraphQLStringOrFloat']>>>;
  _lt?: InputMaybe<Scalars['GraphQLStringOrFloat']>;
  _lte?: InputMaybe<Scalars['GraphQLStringOrFloat']>;
  _nbetween?: InputMaybe<Array<InputMaybe<Scalars['GraphQLStringOrFloat']>>>;
  _neq?: InputMaybe<Scalars['GraphQLStringOrFloat']>;
  _nin?: InputMaybe<Array<InputMaybe<Scalars['GraphQLStringOrFloat']>>>;
  _nnull?: InputMaybe<Scalars['Boolean']>;
  _null?: InputMaybe<Scalars['Boolean']>;
};

export type Pages = {
  __typename?: 'pages';
  color_scheme?: Maybe<Color_Schemes>;
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  friendly_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  parent?: Maybe<Pages>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<Pages_Translations>>>;
  translations_func?: Maybe<Count_Functions>;
  user_created?: Maybe<Directus_Users>;
  user_updated?: Maybe<Directus_Users>;
};


export type PagesColor_SchemeArgs = {
  filter?: InputMaybe<Color_Schemes_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type PagesParentArgs = {
  filter?: InputMaybe<Pages_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type PagesTranslationsArgs = {
  filter?: InputMaybe<Pages_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type PagesUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type PagesUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Pages_Aggregated = {
  __typename?: 'pages_aggregated';
  avg?: Maybe<Pages_Aggregated_Fields>;
  avgDistinct?: Maybe<Pages_Aggregated_Fields>;
  count?: Maybe<Pages_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Pages_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Pages_Aggregated_Fields>;
  min?: Maybe<Pages_Aggregated_Fields>;
  sum?: Maybe<Pages_Aggregated_Fields>;
  sumDistinct?: Maybe<Pages_Aggregated_Fields>;
};

export type Pages_Aggregated_Count = {
  __typename?: 'pages_aggregated_count';
  color_scheme?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  friendly_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  parent?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  translations?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
};

export type Pages_Aggregated_Fields = {
  __typename?: 'pages_aggregated_fields';
  color_scheme?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  parent?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

export type Pages_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Pages_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Pages_Filter>>>;
  color_scheme?: InputMaybe<Color_Schemes_Filter>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  friendly_id?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<Number_Filter_Operators>;
  parent?: InputMaybe<Pages_Filter>;
  sort?: InputMaybe<Number_Filter_Operators>;
  status?: InputMaybe<String_Filter_Operators>;
  translations?: InputMaybe<Pages_Translations_Filter>;
  translations_func?: InputMaybe<Count_Function_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type Pages_Translations = {
  __typename?: 'pages_translations';
  heading?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  languages_code?: Maybe<Languages>;
  pages_id?: Maybe<Pages>;
  sections?: Maybe<Array<Maybe<Pages_Translations_Sections>>>;
  sections_func?: Maybe<Count_Functions>;
  seo?: Maybe<Seo>;
  slug: Scalars['String'];
  title: Scalars['String'];
};


export type Pages_TranslationsLanguages_CodeArgs = {
  filter?: InputMaybe<Languages_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Pages_TranslationsPages_IdArgs = {
  filter?: InputMaybe<Pages_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Pages_TranslationsSectionsArgs = {
  filter?: InputMaybe<Pages_Translations_Sections_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Pages_TranslationsSeoArgs = {
  filter?: InputMaybe<Seo_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Pages_Translations_Aggregated = {
  __typename?: 'pages_translations_aggregated';
  avg?: Maybe<Pages_Translations_Aggregated_Fields>;
  avgDistinct?: Maybe<Pages_Translations_Aggregated_Fields>;
  count?: Maybe<Pages_Translations_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Pages_Translations_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Pages_Translations_Aggregated_Fields>;
  min?: Maybe<Pages_Translations_Aggregated_Fields>;
  sum?: Maybe<Pages_Translations_Aggregated_Fields>;
  sumDistinct?: Maybe<Pages_Translations_Aggregated_Fields>;
};

export type Pages_Translations_Aggregated_Count = {
  __typename?: 'pages_translations_aggregated_count';
  heading?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  languages_code?: Maybe<Scalars['Int']>;
  pages_id?: Maybe<Scalars['Int']>;
  sections?: Maybe<Scalars['Int']>;
  seo?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['Int']>;
};

export type Pages_Translations_Aggregated_Fields = {
  __typename?: 'pages_translations_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  pages_id?: Maybe<Scalars['Float']>;
};

export type Pages_Translations_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Pages_Translations_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Pages_Translations_Filter>>>;
  heading?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<Number_Filter_Operators>;
  languages_code?: InputMaybe<Languages_Filter>;
  pages_id?: InputMaybe<Pages_Filter>;
  sections?: InputMaybe<Pages_Translations_Sections_Filter>;
  sections_func?: InputMaybe<Count_Function_Filter_Operators>;
  seo?: InputMaybe<Seo_Filter>;
  slug?: InputMaybe<String_Filter_Operators>;
  title?: InputMaybe<String_Filter_Operators>;
};

export type Pages_Translations_Sections = {
  __typename?: 'pages_translations_sections';
  collection?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  item?: Maybe<Pages_Translations_Sections_Item_Union>;
  pages_translations_id?: Maybe<Pages_Translations>;
  sort?: Maybe<Scalars['Int']>;
};


export type Pages_Translations_SectionsPages_Translations_IdArgs = {
  filter?: InputMaybe<Pages_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Pages_Translations_Sections_Aggregated = {
  __typename?: 'pages_translations_sections_aggregated';
  avg?: Maybe<Pages_Translations_Sections_Aggregated_Fields>;
  avgDistinct?: Maybe<Pages_Translations_Sections_Aggregated_Fields>;
  count?: Maybe<Pages_Translations_Sections_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Pages_Translations_Sections_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Pages_Translations_Sections_Aggregated_Fields>;
  min?: Maybe<Pages_Translations_Sections_Aggregated_Fields>;
  sum?: Maybe<Pages_Translations_Sections_Aggregated_Fields>;
  sumDistinct?: Maybe<Pages_Translations_Sections_Aggregated_Fields>;
};

export type Pages_Translations_Sections_Aggregated_Count = {
  __typename?: 'pages_translations_sections_aggregated_count';
  collection?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  item?: Maybe<Scalars['Int']>;
  pages_translations_id?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
};

export type Pages_Translations_Sections_Aggregated_Fields = {
  __typename?: 'pages_translations_sections_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  pages_translations_id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

export type Pages_Translations_Sections_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Pages_Translations_Sections_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Pages_Translations_Sections_Filter>>>;
  collection?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<Number_Filter_Operators>;
  item__block_content?: InputMaybe<Block_Content_Filter>;
  item__block_contest?: InputMaybe<Block_Contest_Filter>;
  item__block_faq?: InputMaybe<Block_Faq_Filter>;
  item__block_mdx?: InputMaybe<Block_Mdx_Filter>;
  item__block_stories?: InputMaybe<Block_Stories_Filter>;
  pages_translations_id?: InputMaybe<Pages_Translations_Filter>;
  sort?: InputMaybe<Number_Filter_Operators>;
};

export type Pages_Translations_Sections_Item_Union = Block_Content | Block_Contest | Block_Faq | Block_Mdx | Block_Stories;

export type Product_Facets = {
  __typename?: 'product_facets';
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID'];
  options?: Maybe<Array<Maybe<Product_Facets_Item>>>;
  options_func?: Maybe<Count_Functions>;
  sort?: Maybe<Scalars['Int']>;
  translations?: Maybe<Array<Maybe<Product_Facets_Translations>>>;
  translations_func?: Maybe<Count_Functions>;
  user_created?: Maybe<Directus_Users>;
  user_updated?: Maybe<Directus_Users>;
};


export type Product_FacetsOptionsArgs = {
  filter?: InputMaybe<Product_Facets_Item_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Product_FacetsTranslationsArgs = {
  filter?: InputMaybe<Product_Facets_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Product_FacetsUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Product_FacetsUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Product_Facets_Aggregated = {
  __typename?: 'product_facets_aggregated';
  avg?: Maybe<Product_Facets_Aggregated_Fields>;
  avgDistinct?: Maybe<Product_Facets_Aggregated_Fields>;
  count?: Maybe<Product_Facets_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Product_Facets_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Product_Facets_Aggregated_Fields>;
  min?: Maybe<Product_Facets_Aggregated_Fields>;
  sum?: Maybe<Product_Facets_Aggregated_Fields>;
  sumDistinct?: Maybe<Product_Facets_Aggregated_Fields>;
};

export type Product_Facets_Aggregated_Count = {
  __typename?: 'product_facets_aggregated_count';
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  options?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  translations?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
};

export type Product_Facets_Aggregated_Fields = {
  __typename?: 'product_facets_aggregated_fields';
  sort?: Maybe<Scalars['Float']>;
};

export type Product_Facets_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Product_Facets_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Product_Facets_Filter>>>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  options?: InputMaybe<Product_Facets_Item_Filter>;
  options_func?: InputMaybe<Count_Function_Filter_Operators>;
  sort?: InputMaybe<Number_Filter_Operators>;
  translations?: InputMaybe<Product_Facets_Translations_Filter>;
  translations_func?: InputMaybe<Count_Function_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type Product_Facets_Item = {
  __typename?: 'product_facets_item';
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID'];
  parent?: Maybe<Product_Facets>;
  translations?: Maybe<Array<Maybe<Product_Facets_Item_Translations>>>;
  translations_func?: Maybe<Count_Functions>;
  user_created?: Maybe<Directus_Users>;
  user_updated?: Maybe<Directus_Users>;
};


export type Product_Facets_ItemParentArgs = {
  filter?: InputMaybe<Product_Facets_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Product_Facets_ItemTranslationsArgs = {
  filter?: InputMaybe<Product_Facets_Item_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Product_Facets_ItemUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Product_Facets_ItemUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Product_Facets_Item_Aggregated = {
  __typename?: 'product_facets_item_aggregated';
  avg?: Maybe<Product_Facets_Item_Aggregated_Fields>;
  avgDistinct?: Maybe<Product_Facets_Item_Aggregated_Fields>;
  count?: Maybe<Product_Facets_Item_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Product_Facets_Item_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Product_Facets_Item_Aggregated_Fields>;
  min?: Maybe<Product_Facets_Item_Aggregated_Fields>;
  sum?: Maybe<Product_Facets_Item_Aggregated_Fields>;
  sumDistinct?: Maybe<Product_Facets_Item_Aggregated_Fields>;
};

export type Product_Facets_Item_Aggregated_Count = {
  __typename?: 'product_facets_item_aggregated_count';
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  parent?: Maybe<Scalars['Int']>;
  translations?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
};

export type Product_Facets_Item_Aggregated_Fields = {
  __typename?: 'product_facets_item_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
};

export type Product_Facets_Item_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Product_Facets_Item_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Product_Facets_Item_Filter>>>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<Number_Filter_Operators>;
  parent?: InputMaybe<Product_Facets_Filter>;
  translations?: InputMaybe<Product_Facets_Item_Translations_Filter>;
  translations_func?: InputMaybe<Count_Function_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type Product_Facets_Item_Translations = {
  __typename?: 'product_facets_item_translations';
  id: Scalars['ID'];
  languages_code?: Maybe<Languages>;
  name?: Maybe<Scalars['String']>;
  product_facets_item_id?: Maybe<Product_Facets_Item>;
};


export type Product_Facets_Item_TranslationsLanguages_CodeArgs = {
  filter?: InputMaybe<Languages_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Product_Facets_Item_TranslationsProduct_Facets_Item_IdArgs = {
  filter?: InputMaybe<Product_Facets_Item_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Product_Facets_Item_Translations_Aggregated = {
  __typename?: 'product_facets_item_translations_aggregated';
  avg?: Maybe<Product_Facets_Item_Translations_Aggregated_Fields>;
  avgDistinct?: Maybe<Product_Facets_Item_Translations_Aggregated_Fields>;
  count?: Maybe<Product_Facets_Item_Translations_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Product_Facets_Item_Translations_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Product_Facets_Item_Translations_Aggregated_Fields>;
  min?: Maybe<Product_Facets_Item_Translations_Aggregated_Fields>;
  sum?: Maybe<Product_Facets_Item_Translations_Aggregated_Fields>;
  sumDistinct?: Maybe<Product_Facets_Item_Translations_Aggregated_Fields>;
};

export type Product_Facets_Item_Translations_Aggregated_Count = {
  __typename?: 'product_facets_item_translations_aggregated_count';
  id?: Maybe<Scalars['Int']>;
  languages_code?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  product_facets_item_id?: Maybe<Scalars['Int']>;
};

export type Product_Facets_Item_Translations_Aggregated_Fields = {
  __typename?: 'product_facets_item_translations_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  product_facets_item_id?: Maybe<Scalars['Float']>;
};

export type Product_Facets_Item_Translations_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Product_Facets_Item_Translations_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Product_Facets_Item_Translations_Filter>>>;
  id?: InputMaybe<Number_Filter_Operators>;
  languages_code?: InputMaybe<Languages_Filter>;
  name?: InputMaybe<String_Filter_Operators>;
  product_facets_item_id?: InputMaybe<Product_Facets_Item_Filter>;
};

export type Product_Facets_Translations = {
  __typename?: 'product_facets_translations';
  id: Scalars['ID'];
  languages_code?: Maybe<Languages>;
  name?: Maybe<Scalars['String']>;
  product_facets_id?: Maybe<Product_Facets>;
};


export type Product_Facets_TranslationsLanguages_CodeArgs = {
  filter?: InputMaybe<Languages_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Product_Facets_TranslationsProduct_Facets_IdArgs = {
  filter?: InputMaybe<Product_Facets_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Product_Facets_Translations_Aggregated = {
  __typename?: 'product_facets_translations_aggregated';
  avg?: Maybe<Product_Facets_Translations_Aggregated_Fields>;
  avgDistinct?: Maybe<Product_Facets_Translations_Aggregated_Fields>;
  count?: Maybe<Product_Facets_Translations_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Product_Facets_Translations_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Product_Facets_Translations_Aggregated_Fields>;
  min?: Maybe<Product_Facets_Translations_Aggregated_Fields>;
  sum?: Maybe<Product_Facets_Translations_Aggregated_Fields>;
  sumDistinct?: Maybe<Product_Facets_Translations_Aggregated_Fields>;
};

export type Product_Facets_Translations_Aggregated_Count = {
  __typename?: 'product_facets_translations_aggregated_count';
  id?: Maybe<Scalars['Int']>;
  languages_code?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  product_facets_id?: Maybe<Scalars['Int']>;
};

export type Product_Facets_Translations_Aggregated_Fields = {
  __typename?: 'product_facets_translations_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
};

export type Product_Facets_Translations_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Product_Facets_Translations_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Product_Facets_Translations_Filter>>>;
  id?: InputMaybe<Number_Filter_Operators>;
  languages_code?: InputMaybe<Languages_Filter>;
  name?: InputMaybe<String_Filter_Operators>;
  product_facets_id?: InputMaybe<Product_Facets_Filter>;
};

export type Product_Types = {
  __typename?: 'product_types';
  available_facets?: Maybe<Array<Maybe<Product_Types_Product_Facets>>>;
  available_facets_func?: Maybe<Count_Functions>;
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID'];
  products?: Maybe<Array<Maybe<Products>>>;
  products_func?: Maybe<Count_Functions>;
  seo?: Maybe<Seo>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<Product_Types_Translations>>>;
  translations_func?: Maybe<Count_Functions>;
  user_created?: Maybe<Directus_Users>;
  user_updated?: Maybe<Directus_Users>;
};


export type Product_TypesAvailable_FacetsArgs = {
  filter?: InputMaybe<Product_Types_Product_Facets_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Product_TypesProductsArgs = {
  filter?: InputMaybe<Products_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Product_TypesSeoArgs = {
  filter?: InputMaybe<Seo_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Product_TypesTranslationsArgs = {
  filter?: InputMaybe<Product_Types_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Product_TypesUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Product_TypesUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Product_Types_Aggregated = {
  __typename?: 'product_types_aggregated';
  avg?: Maybe<Product_Types_Aggregated_Fields>;
  avgDistinct?: Maybe<Product_Types_Aggregated_Fields>;
  count?: Maybe<Product_Types_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Product_Types_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Product_Types_Aggregated_Fields>;
  min?: Maybe<Product_Types_Aggregated_Fields>;
  sum?: Maybe<Product_Types_Aggregated_Fields>;
  sumDistinct?: Maybe<Product_Types_Aggregated_Fields>;
};

export type Product_Types_Aggregated_Count = {
  __typename?: 'product_types_aggregated_count';
  available_facets?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  products?: Maybe<Scalars['Int']>;
  seo?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  translations?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
};

export type Product_Types_Aggregated_Fields = {
  __typename?: 'product_types_aggregated_fields';
  sort?: Maybe<Scalars['Float']>;
};

export type Product_Types_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Product_Types_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Product_Types_Filter>>>;
  available_facets?: InputMaybe<Product_Types_Product_Facets_Filter>;
  available_facets_func?: InputMaybe<Count_Function_Filter_Operators>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  products?: InputMaybe<Products_Filter>;
  products_func?: InputMaybe<Count_Function_Filter_Operators>;
  seo?: InputMaybe<Seo_Filter>;
  sort?: InputMaybe<Number_Filter_Operators>;
  status?: InputMaybe<String_Filter_Operators>;
  translations?: InputMaybe<Product_Types_Translations_Filter>;
  translations_func?: InputMaybe<Count_Function_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type Product_Types_Grid = {
  __typename?: 'product_types_grid';
  collection?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  item?: Maybe<Product_Types_Grid_Item_Union>;
  product_types_id?: Maybe<Product_Types>;
};


export type Product_Types_GridProduct_Types_IdArgs = {
  filter?: InputMaybe<Product_Types_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Product_Types_Grid_Aggregated = {
  __typename?: 'product_types_grid_aggregated';
  avg?: Maybe<Product_Types_Grid_Aggregated_Fields>;
  avgDistinct?: Maybe<Product_Types_Grid_Aggregated_Fields>;
  count?: Maybe<Product_Types_Grid_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Product_Types_Grid_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Product_Types_Grid_Aggregated_Fields>;
  min?: Maybe<Product_Types_Grid_Aggregated_Fields>;
  sum?: Maybe<Product_Types_Grid_Aggregated_Fields>;
  sumDistinct?: Maybe<Product_Types_Grid_Aggregated_Fields>;
};

export type Product_Types_Grid_Aggregated_Count = {
  __typename?: 'product_types_grid_aggregated_count';
  collection?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  item?: Maybe<Scalars['Int']>;
  product_types_id?: Maybe<Scalars['Int']>;
};

export type Product_Types_Grid_Aggregated_Fields = {
  __typename?: 'product_types_grid_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
};

export type Product_Types_Grid_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Product_Types_Grid_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Product_Types_Grid_Filter>>>;
  collection?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<Number_Filter_Operators>;
  item__animations?: InputMaybe<Animations_Filter>;
  item__products?: InputMaybe<Products_Filter>;
  product_types_id?: InputMaybe<Product_Types_Filter>;
};

export type Product_Types_Grid_Item_Union = Animations | Products;

export type Product_Types_Product_Facets = {
  __typename?: 'product_types_product_facets';
  id: Scalars['ID'];
  product_facets_id?: Maybe<Product_Facets>;
  product_types_id?: Maybe<Product_Types>;
};


export type Product_Types_Product_FacetsProduct_Facets_IdArgs = {
  filter?: InputMaybe<Product_Facets_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Product_Types_Product_FacetsProduct_Types_IdArgs = {
  filter?: InputMaybe<Product_Types_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Product_Types_Product_Facets_Aggregated = {
  __typename?: 'product_types_product_facets_aggregated';
  avg?: Maybe<Product_Types_Product_Facets_Aggregated_Fields>;
  avgDistinct?: Maybe<Product_Types_Product_Facets_Aggregated_Fields>;
  count?: Maybe<Product_Types_Product_Facets_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Product_Types_Product_Facets_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Product_Types_Product_Facets_Aggregated_Fields>;
  min?: Maybe<Product_Types_Product_Facets_Aggregated_Fields>;
  sum?: Maybe<Product_Types_Product_Facets_Aggregated_Fields>;
  sumDistinct?: Maybe<Product_Types_Product_Facets_Aggregated_Fields>;
};

export type Product_Types_Product_Facets_Aggregated_Count = {
  __typename?: 'product_types_product_facets_aggregated_count';
  id?: Maybe<Scalars['Int']>;
  product_facets_id?: Maybe<Scalars['Int']>;
  product_types_id?: Maybe<Scalars['Int']>;
};

export type Product_Types_Product_Facets_Aggregated_Fields = {
  __typename?: 'product_types_product_facets_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
};

export type Product_Types_Product_Facets_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Product_Types_Product_Facets_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Product_Types_Product_Facets_Filter>>>;
  id?: InputMaybe<Number_Filter_Operators>;
  product_facets_id?: InputMaybe<Product_Facets_Filter>;
  product_types_id?: InputMaybe<Product_Types_Filter>;
};

export type Product_Types_Translations = {
  __typename?: 'product_types_translations';
  id: Scalars['ID'];
  languages_code?: Maybe<Languages>;
  product_types_id?: Maybe<Product_Types>;
  title?: Maybe<Scalars['String']>;
};


export type Product_Types_TranslationsLanguages_CodeArgs = {
  filter?: InputMaybe<Languages_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Product_Types_TranslationsProduct_Types_IdArgs = {
  filter?: InputMaybe<Product_Types_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Product_Types_Translations_Aggregated = {
  __typename?: 'product_types_translations_aggregated';
  avg?: Maybe<Product_Types_Translations_Aggregated_Fields>;
  avgDistinct?: Maybe<Product_Types_Translations_Aggregated_Fields>;
  count?: Maybe<Product_Types_Translations_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Product_Types_Translations_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Product_Types_Translations_Aggregated_Fields>;
  min?: Maybe<Product_Types_Translations_Aggregated_Fields>;
  sum?: Maybe<Product_Types_Translations_Aggregated_Fields>;
  sumDistinct?: Maybe<Product_Types_Translations_Aggregated_Fields>;
};

export type Product_Types_Translations_Aggregated_Count = {
  __typename?: 'product_types_translations_aggregated_count';
  id?: Maybe<Scalars['Int']>;
  languages_code?: Maybe<Scalars['Int']>;
  product_types_id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['Int']>;
};

export type Product_Types_Translations_Aggregated_Fields = {
  __typename?: 'product_types_translations_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
};

export type Product_Types_Translations_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Product_Types_Translations_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Product_Types_Translations_Filter>>>;
  id?: InputMaybe<Number_Filter_Operators>;
  languages_code?: InputMaybe<Languages_Filter>;
  product_types_id?: InputMaybe<Product_Types_Filter>;
  title?: InputMaybe<String_Filter_Operators>;
};

export type Products = {
  __typename?: 'products';
  additional_images?: Maybe<Array<Maybe<Products_Files_1>>>;
  additional_images_func?: Maybe<Count_Functions>;
  animals?: Maybe<Animals>;
  animation?: Maybe<Animations>;
  background_pattern?: Maybe<Directus_Files>;
  claims?: Maybe<Array<Maybe<Products_Claims>>>;
  claims_func?: Maybe<Count_Functions>;
  color_scheme?: Maybe<Color_Schemes>;
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  facet_options?: Maybe<Array<Maybe<Products_Product_Facets_Item>>>;
  facet_options_func?: Maybe<Count_Functions>;
  featured_image?: Maybe<Directus_Files>;
  flavor_icon?: Maybe<Directus_Files>;
  id: Scalars['ID'];
  product_type?: Maybe<Product_Types>;
  recommendations?: Maybe<Recommendations>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<Products_Translations>>>;
  translations_func?: Maybe<Count_Functions>;
  user_created?: Maybe<Directus_Users>;
  user_updated?: Maybe<Directus_Users>;
};


export type ProductsAdditional_ImagesArgs = {
  filter?: InputMaybe<Products_Files_1_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ProductsAnimalsArgs = {
  filter?: InputMaybe<Animals_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ProductsAnimationArgs = {
  filter?: InputMaybe<Animations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ProductsBackground_PatternArgs = {
  filter?: InputMaybe<Directus_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ProductsClaimsArgs = {
  filter?: InputMaybe<Products_Claims_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ProductsColor_SchemeArgs = {
  filter?: InputMaybe<Color_Schemes_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ProductsFacet_OptionsArgs = {
  filter?: InputMaybe<Products_Product_Facets_Item_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ProductsFeatured_ImageArgs = {
  filter?: InputMaybe<Directus_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ProductsFlavor_IconArgs = {
  filter?: InputMaybe<Directus_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ProductsProduct_TypeArgs = {
  filter?: InputMaybe<Product_Types_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ProductsRecommendationsArgs = {
  filter?: InputMaybe<Recommendations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ProductsTranslationsArgs = {
  filter?: InputMaybe<Products_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ProductsUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type ProductsUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Products_Aggregated = {
  __typename?: 'products_aggregated';
  avg?: Maybe<Products_Aggregated_Fields>;
  avgDistinct?: Maybe<Products_Aggregated_Fields>;
  count?: Maybe<Products_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Products_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Products_Aggregated_Fields>;
  min?: Maybe<Products_Aggregated_Fields>;
  sum?: Maybe<Products_Aggregated_Fields>;
  sumDistinct?: Maybe<Products_Aggregated_Fields>;
};

export type Products_Aggregated_Count = {
  __typename?: 'products_aggregated_count';
  additional_images?: Maybe<Scalars['Int']>;
  animals?: Maybe<Scalars['Int']>;
  animation?: Maybe<Scalars['Int']>;
  background_pattern?: Maybe<Scalars['Int']>;
  claims?: Maybe<Scalars['Int']>;
  color_scheme?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  facet_options?: Maybe<Scalars['Int']>;
  featured_image?: Maybe<Scalars['Int']>;
  flavor_icon?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  product_type?: Maybe<Scalars['Int']>;
  recommendations?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  translations?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
};

export type Products_Aggregated_Fields = {
  __typename?: 'products_aggregated_fields';
  animation?: Maybe<Scalars['Float']>;
  color_scheme?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  recommendations?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

export type Products_Animals = {
  __typename?: 'products_animals';
  animals_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  products_id?: Maybe<Scalars['Int']>;
};

export type Products_Animals_Aggregated = {
  __typename?: 'products_animals_aggregated';
  avg?: Maybe<Products_Animals_Aggregated_Fields>;
  avgDistinct?: Maybe<Products_Animals_Aggregated_Fields>;
  count?: Maybe<Products_Animals_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Products_Animals_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Products_Animals_Aggregated_Fields>;
  min?: Maybe<Products_Animals_Aggregated_Fields>;
  sum?: Maybe<Products_Animals_Aggregated_Fields>;
  sumDistinct?: Maybe<Products_Animals_Aggregated_Fields>;
};

export type Products_Animals_Aggregated_Count = {
  __typename?: 'products_animals_aggregated_count';
  animals_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  products_id?: Maybe<Scalars['Int']>;
};

export type Products_Animals_Aggregated_Fields = {
  __typename?: 'products_animals_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  products_id?: Maybe<Scalars['Float']>;
};

export type Products_Animals_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Products_Animals_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Products_Animals_Filter>>>;
  animals_id?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<Number_Filter_Operators>;
  products_id?: InputMaybe<Number_Filter_Operators>;
};

export type Products_Claims = {
  __typename?: 'products_claims';
  claims_id?: Maybe<Claims>;
  id: Scalars['ID'];
  products_id?: Maybe<Products>;
};


export type Products_ClaimsClaims_IdArgs = {
  filter?: InputMaybe<Claims_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Products_ClaimsProducts_IdArgs = {
  filter?: InputMaybe<Products_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Products_Claims_Aggregated = {
  __typename?: 'products_claims_aggregated';
  avg?: Maybe<Products_Claims_Aggregated_Fields>;
  avgDistinct?: Maybe<Products_Claims_Aggregated_Fields>;
  count?: Maybe<Products_Claims_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Products_Claims_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Products_Claims_Aggregated_Fields>;
  min?: Maybe<Products_Claims_Aggregated_Fields>;
  sum?: Maybe<Products_Claims_Aggregated_Fields>;
  sumDistinct?: Maybe<Products_Claims_Aggregated_Fields>;
};

export type Products_Claims_Aggregated_Count = {
  __typename?: 'products_claims_aggregated_count';
  claims_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  products_id?: Maybe<Scalars['Int']>;
};

export type Products_Claims_Aggregated_Fields = {
  __typename?: 'products_claims_aggregated_fields';
  claims_id?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  products_id?: Maybe<Scalars['Float']>;
};

export type Products_Claims_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Products_Claims_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Products_Claims_Filter>>>;
  claims_id?: InputMaybe<Claims_Filter>;
  id?: InputMaybe<Number_Filter_Operators>;
  products_id?: InputMaybe<Products_Filter>;
};

export type Products_Files = {
  __typename?: 'products_files';
  directus_files_id?: Maybe<Directus_Files>;
  id: Scalars['ID'];
  products_id?: Maybe<Products>;
};


export type Products_FilesDirectus_Files_IdArgs = {
  filter?: InputMaybe<Directus_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Products_FilesProducts_IdArgs = {
  filter?: InputMaybe<Products_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Products_Files_1 = {
  __typename?: 'products_files_1';
  directus_files_id?: Maybe<Directus_Files>;
  id: Scalars['ID'];
  products_id?: Maybe<Products>;
};


export type Products_Files_1Directus_Files_IdArgs = {
  filter?: InputMaybe<Directus_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Products_Files_1Products_IdArgs = {
  filter?: InputMaybe<Products_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Products_Files_1_Aggregated = {
  __typename?: 'products_files_1_aggregated';
  avg?: Maybe<Products_Files_1_Aggregated_Fields>;
  avgDistinct?: Maybe<Products_Files_1_Aggregated_Fields>;
  count?: Maybe<Products_Files_1_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Products_Files_1_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Products_Files_1_Aggregated_Fields>;
  min?: Maybe<Products_Files_1_Aggregated_Fields>;
  sum?: Maybe<Products_Files_1_Aggregated_Fields>;
  sumDistinct?: Maybe<Products_Files_1_Aggregated_Fields>;
};

export type Products_Files_1_Aggregated_Count = {
  __typename?: 'products_files_1_aggregated_count';
  directus_files_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  products_id?: Maybe<Scalars['Int']>;
};

export type Products_Files_1_Aggregated_Fields = {
  __typename?: 'products_files_1_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  products_id?: Maybe<Scalars['Float']>;
};

export type Products_Files_1_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Products_Files_1_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Products_Files_1_Filter>>>;
  directus_files_id?: InputMaybe<Directus_Files_Filter>;
  id?: InputMaybe<Number_Filter_Operators>;
  products_id?: InputMaybe<Products_Filter>;
};

export type Products_Files_Aggregated = {
  __typename?: 'products_files_aggregated';
  avg?: Maybe<Products_Files_Aggregated_Fields>;
  avgDistinct?: Maybe<Products_Files_Aggregated_Fields>;
  count?: Maybe<Products_Files_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Products_Files_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Products_Files_Aggregated_Fields>;
  min?: Maybe<Products_Files_Aggregated_Fields>;
  sum?: Maybe<Products_Files_Aggregated_Fields>;
  sumDistinct?: Maybe<Products_Files_Aggregated_Fields>;
};

export type Products_Files_Aggregated_Count = {
  __typename?: 'products_files_aggregated_count';
  directus_files_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  products_id?: Maybe<Scalars['Int']>;
};

export type Products_Files_Aggregated_Fields = {
  __typename?: 'products_files_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  products_id?: Maybe<Scalars['Float']>;
};

export type Products_Files_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Products_Files_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Products_Files_Filter>>>;
  directus_files_id?: InputMaybe<Directus_Files_Filter>;
  id?: InputMaybe<Number_Filter_Operators>;
  products_id?: InputMaybe<Products_Filter>;
};

export type Products_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Products_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Products_Filter>>>;
  additional_images?: InputMaybe<Products_Files_1_Filter>;
  additional_images_func?: InputMaybe<Count_Function_Filter_Operators>;
  animals?: InputMaybe<Animals_Filter>;
  animation?: InputMaybe<Animations_Filter>;
  background_pattern?: InputMaybe<Directus_Files_Filter>;
  claims?: InputMaybe<Products_Claims_Filter>;
  claims_func?: InputMaybe<Count_Function_Filter_Operators>;
  color_scheme?: InputMaybe<Color_Schemes_Filter>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  facet_options?: InputMaybe<Products_Product_Facets_Item_Filter>;
  facet_options_func?: InputMaybe<Count_Function_Filter_Operators>;
  featured_image?: InputMaybe<Directus_Files_Filter>;
  flavor_icon?: InputMaybe<Directus_Files_Filter>;
  id?: InputMaybe<Number_Filter_Operators>;
  product_type?: InputMaybe<Product_Types_Filter>;
  recommendations?: InputMaybe<Recommendations_Filter>;
  sort?: InputMaybe<Number_Filter_Operators>;
  status?: InputMaybe<String_Filter_Operators>;
  translations?: InputMaybe<Products_Translations_Filter>;
  translations_func?: InputMaybe<Count_Function_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type Products_Product_Facets_Item = {
  __typename?: 'products_product_facets_item';
  id: Scalars['ID'];
  product_facets_item_id?: Maybe<Product_Facets_Item>;
  products_id?: Maybe<Products>;
};


export type Products_Product_Facets_ItemProduct_Facets_Item_IdArgs = {
  filter?: InputMaybe<Product_Facets_Item_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Products_Product_Facets_ItemProducts_IdArgs = {
  filter?: InputMaybe<Products_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Products_Product_Facets_Item_Aggregated = {
  __typename?: 'products_product_facets_item_aggregated';
  avg?: Maybe<Products_Product_Facets_Item_Aggregated_Fields>;
  avgDistinct?: Maybe<Products_Product_Facets_Item_Aggregated_Fields>;
  count?: Maybe<Products_Product_Facets_Item_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Products_Product_Facets_Item_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Products_Product_Facets_Item_Aggregated_Fields>;
  min?: Maybe<Products_Product_Facets_Item_Aggregated_Fields>;
  sum?: Maybe<Products_Product_Facets_Item_Aggregated_Fields>;
  sumDistinct?: Maybe<Products_Product_Facets_Item_Aggregated_Fields>;
};

export type Products_Product_Facets_Item_Aggregated_Count = {
  __typename?: 'products_product_facets_item_aggregated_count';
  id?: Maybe<Scalars['Int']>;
  product_facets_item_id?: Maybe<Scalars['Int']>;
  products_id?: Maybe<Scalars['Int']>;
};

export type Products_Product_Facets_Item_Aggregated_Fields = {
  __typename?: 'products_product_facets_item_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  product_facets_item_id?: Maybe<Scalars['Float']>;
  products_id?: Maybe<Scalars['Float']>;
};

export type Products_Product_Facets_Item_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Products_Product_Facets_Item_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Products_Product_Facets_Item_Filter>>>;
  id?: InputMaybe<Number_Filter_Operators>;
  product_facets_item_id?: InputMaybe<Product_Facets_Item_Filter>;
  products_id?: InputMaybe<Products_Filter>;
};

export type Products_Products = {
  __typename?: 'products_products';
  id: Scalars['ID'];
  products_id?: Maybe<Products>;
  related_products_id?: Maybe<Products>;
};


export type Products_ProductsProducts_IdArgs = {
  filter?: InputMaybe<Products_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Products_ProductsRelated_Products_IdArgs = {
  filter?: InputMaybe<Products_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Products_Products_Aggregated = {
  __typename?: 'products_products_aggregated';
  avg?: Maybe<Products_Products_Aggregated_Fields>;
  avgDistinct?: Maybe<Products_Products_Aggregated_Fields>;
  count?: Maybe<Products_Products_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Products_Products_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Products_Products_Aggregated_Fields>;
  min?: Maybe<Products_Products_Aggregated_Fields>;
  sum?: Maybe<Products_Products_Aggregated_Fields>;
  sumDistinct?: Maybe<Products_Products_Aggregated_Fields>;
};

export type Products_Products_Aggregated_Count = {
  __typename?: 'products_products_aggregated_count';
  id?: Maybe<Scalars['Int']>;
  products_id?: Maybe<Scalars['Int']>;
  related_products_id?: Maybe<Scalars['Int']>;
};

export type Products_Products_Aggregated_Fields = {
  __typename?: 'products_products_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  products_id?: Maybe<Scalars['Float']>;
  related_products_id?: Maybe<Scalars['Float']>;
};

export type Products_Products_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Products_Products_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Products_Products_Filter>>>;
  id?: InputMaybe<Number_Filter_Operators>;
  products_id?: InputMaybe<Products_Filter>;
  related_products_id?: InputMaybe<Products_Filter>;
};

export type Products_Translations = {
  __typename?: 'products_translations';
  buy_cta?: Maybe<Scalars['String']>;
  buy_cta_rens?: Maybe<Scalars['String']>;
  calory_content?: Maybe<Scalars['String']>;
  /** N'est plus utilisé */
  claims?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  feeding_guideline?: Maybe<Scalars['String']>;
  flavor?: Maybe<Scalars['String']>;
  guaranteed_analysis?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  ingredients?: Maybe<Scalars['String']>;
  languages_code?: Maybe<Languages>;
  products_id?: Maybe<Products>;
  ressources?: Maybe<Scalars['String']>;
  seo?: Maybe<Seo>;
  sizes?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  specifications?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};


export type Products_TranslationsLanguages_CodeArgs = {
  filter?: InputMaybe<Languages_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Products_TranslationsProducts_IdArgs = {
  filter?: InputMaybe<Products_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Products_TranslationsSeoArgs = {
  filter?: InputMaybe<Seo_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Products_Translations_Aggregated = {
  __typename?: 'products_translations_aggregated';
  avg?: Maybe<Products_Translations_Aggregated_Fields>;
  avgDistinct?: Maybe<Products_Translations_Aggregated_Fields>;
  count?: Maybe<Products_Translations_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Products_Translations_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Products_Translations_Aggregated_Fields>;
  min?: Maybe<Products_Translations_Aggregated_Fields>;
  sum?: Maybe<Products_Translations_Aggregated_Fields>;
  sumDistinct?: Maybe<Products_Translations_Aggregated_Fields>;
};

export type Products_Translations_Aggregated_Count = {
  __typename?: 'products_translations_aggregated_count';
  buy_cta?: Maybe<Scalars['Int']>;
  buy_cta_rens?: Maybe<Scalars['Int']>;
  calory_content?: Maybe<Scalars['Int']>;
  /** N'est plus utilisé */
  claims?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['Int']>;
  feeding_guideline?: Maybe<Scalars['Int']>;
  flavor?: Maybe<Scalars['Int']>;
  guaranteed_analysis?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  ingredients?: Maybe<Scalars['Int']>;
  languages_code?: Maybe<Scalars['Int']>;
  products_id?: Maybe<Scalars['Int']>;
  ressources?: Maybe<Scalars['Int']>;
  seo?: Maybe<Scalars['Int']>;
  sizes?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['Int']>;
  specifications?: Maybe<Scalars['Int']>;
  subtitle?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['Int']>;
};

export type Products_Translations_Aggregated_Fields = {
  __typename?: 'products_translations_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  products_id?: Maybe<Scalars['Float']>;
};

export type Products_Translations_Files = {
  __typename?: 'products_translations_files';
  directus_files_id?: Maybe<Directus_Files>;
  id: Scalars['ID'];
  products_translations_id?: Maybe<Products_Translations>;
};


export type Products_Translations_FilesDirectus_Files_IdArgs = {
  filter?: InputMaybe<Directus_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Products_Translations_FilesProducts_Translations_IdArgs = {
  filter?: InputMaybe<Products_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Products_Translations_Files_Aggregated = {
  __typename?: 'products_translations_files_aggregated';
  avg?: Maybe<Products_Translations_Files_Aggregated_Fields>;
  avgDistinct?: Maybe<Products_Translations_Files_Aggregated_Fields>;
  count?: Maybe<Products_Translations_Files_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Products_Translations_Files_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Products_Translations_Files_Aggregated_Fields>;
  min?: Maybe<Products_Translations_Files_Aggregated_Fields>;
  sum?: Maybe<Products_Translations_Files_Aggregated_Fields>;
  sumDistinct?: Maybe<Products_Translations_Files_Aggregated_Fields>;
};

export type Products_Translations_Files_Aggregated_Count = {
  __typename?: 'products_translations_files_aggregated_count';
  directus_files_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  products_translations_id?: Maybe<Scalars['Int']>;
};

export type Products_Translations_Files_Aggregated_Fields = {
  __typename?: 'products_translations_files_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  products_translations_id?: Maybe<Scalars['Float']>;
};

export type Products_Translations_Files_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Products_Translations_Files_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Products_Translations_Files_Filter>>>;
  directus_files_id?: InputMaybe<Directus_Files_Filter>;
  id?: InputMaybe<Number_Filter_Operators>;
  products_translations_id?: InputMaybe<Products_Translations_Filter>;
};

export type Products_Translations_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Products_Translations_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Products_Translations_Filter>>>;
  buy_cta?: InputMaybe<String_Filter_Operators>;
  buy_cta_rens?: InputMaybe<String_Filter_Operators>;
  calory_content?: InputMaybe<String_Filter_Operators>;
  claims?: InputMaybe<String_Filter_Operators>;
  description?: InputMaybe<String_Filter_Operators>;
  feeding_guideline?: InputMaybe<String_Filter_Operators>;
  flavor?: InputMaybe<String_Filter_Operators>;
  guaranteed_analysis?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<Number_Filter_Operators>;
  ingredients?: InputMaybe<String_Filter_Operators>;
  languages_code?: InputMaybe<Languages_Filter>;
  products_id?: InputMaybe<Products_Filter>;
  ressources?: InputMaybe<String_Filter_Operators>;
  seo?: InputMaybe<Seo_Filter>;
  sizes?: InputMaybe<String_Filter_Operators>;
  slug?: InputMaybe<String_Filter_Operators>;
  specifications?: InputMaybe<String_Filter_Operators>;
  subtitle?: InputMaybe<String_Filter_Operators>;
  title?: InputMaybe<String_Filter_Operators>;
};

export type Recommendations = {
  __typename?: 'recommendations';
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID'];
  recommended_products?: Maybe<Array<Maybe<Recommendations_Products>>>;
  recommended_products_func?: Maybe<Count_Functions>;
  sort?: Maybe<Scalars['Int']>;
  /** Used internally to identify the recommendations */
  title?: Maybe<Scalars['String']>;
  user_created?: Maybe<Directus_Users>;
  user_updated?: Maybe<Directus_Users>;
};


export type RecommendationsRecommended_ProductsArgs = {
  filter?: InputMaybe<Recommendations_Products_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type RecommendationsUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type RecommendationsUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Recommendations_Aggregated = {
  __typename?: 'recommendations_aggregated';
  avg?: Maybe<Recommendations_Aggregated_Fields>;
  avgDistinct?: Maybe<Recommendations_Aggregated_Fields>;
  count?: Maybe<Recommendations_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Recommendations_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Recommendations_Aggregated_Fields>;
  min?: Maybe<Recommendations_Aggregated_Fields>;
  sum?: Maybe<Recommendations_Aggregated_Fields>;
  sumDistinct?: Maybe<Recommendations_Aggregated_Fields>;
};

export type Recommendations_Aggregated_Count = {
  __typename?: 'recommendations_aggregated_count';
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  recommended_products?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  /** Used internally to identify the recommendations */
  title?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
};

export type Recommendations_Aggregated_Fields = {
  __typename?: 'recommendations_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

export type Recommendations_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Recommendations_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Recommendations_Filter>>>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<Number_Filter_Operators>;
  recommended_products?: InputMaybe<Recommendations_Products_Filter>;
  recommended_products_func?: InputMaybe<Count_Function_Filter_Operators>;
  sort?: InputMaybe<Number_Filter_Operators>;
  title?: InputMaybe<String_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type Recommendations_Products = {
  __typename?: 'recommendations_products';
  id: Scalars['ID'];
  products_id?: Maybe<Products>;
  recommendations_id?: Maybe<Recommendations>;
};


export type Recommendations_ProductsProducts_IdArgs = {
  filter?: InputMaybe<Products_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Recommendations_ProductsRecommendations_IdArgs = {
  filter?: InputMaybe<Recommendations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Recommendations_Products_Aggregated = {
  __typename?: 'recommendations_products_aggregated';
  avg?: Maybe<Recommendations_Products_Aggregated_Fields>;
  avgDistinct?: Maybe<Recommendations_Products_Aggregated_Fields>;
  count?: Maybe<Recommendations_Products_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Recommendations_Products_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Recommendations_Products_Aggregated_Fields>;
  min?: Maybe<Recommendations_Products_Aggregated_Fields>;
  sum?: Maybe<Recommendations_Products_Aggregated_Fields>;
  sumDistinct?: Maybe<Recommendations_Products_Aggregated_Fields>;
};

export type Recommendations_Products_Aggregated_Count = {
  __typename?: 'recommendations_products_aggregated_count';
  id?: Maybe<Scalars['Int']>;
  products_id?: Maybe<Scalars['Int']>;
  recommendations_id?: Maybe<Scalars['Int']>;
};

export type Recommendations_Products_Aggregated_Fields = {
  __typename?: 'recommendations_products_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  products_id?: Maybe<Scalars['Float']>;
  recommendations_id?: Maybe<Scalars['Float']>;
};

export type Recommendations_Products_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Recommendations_Products_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Recommendations_Products_Filter>>>;
  id?: InputMaybe<Number_Filter_Operators>;
  products_id?: InputMaybe<Products_Filter>;
  recommendations_id?: InputMaybe<Recommendations_Filter>;
};

export type Seo = {
  __typename?: 'seo';
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  thumbnail?: Maybe<Directus_Files>;
  title?: Maybe<Scalars['String']>;
  user_created?: Maybe<Directus_Users>;
  user_updated?: Maybe<Directus_Users>;
};


export type SeoThumbnailArgs = {
  filter?: InputMaybe<Directus_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type SeoUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type SeoUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Seo_Aggregated = {
  __typename?: 'seo_aggregated';
  count?: Maybe<Seo_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Seo_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
};

export type Seo_Aggregated_Count = {
  __typename?: 'seo_aggregated_count';
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  thumbnail?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
};

export type Seo_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Seo_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Seo_Filter>>>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  description?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  thumbnail?: InputMaybe<Directus_Files_Filter>;
  title?: InputMaybe<String_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type Settings = {
  __typename?: 'settings';
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  environment?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mondou_logo?: Maybe<Directus_Files>;
  renspet_logo?: Maybe<Directus_Files>;
  storerocket_account_id?: Maybe<Scalars['String']>;
  storerocket_enabled_filters?: Maybe<Scalars['String']>;
  storerocket_filters?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<Settings_Translations>>>;
  translations_func?: Maybe<Count_Functions>;
  user_updated?: Maybe<Directus_Users>;
};


export type SettingsMondou_LogoArgs = {
  filter?: InputMaybe<Directus_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type SettingsRenspet_LogoArgs = {
  filter?: InputMaybe<Directus_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type SettingsTranslationsArgs = {
  filter?: InputMaybe<Settings_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type SettingsUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Settings_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Settings_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Settings_Filter>>>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  environment?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<Number_Filter_Operators>;
  mondou_logo?: InputMaybe<Directus_Files_Filter>;
  renspet_logo?: InputMaybe<Directus_Files_Filter>;
  storerocket_account_id?: InputMaybe<String_Filter_Operators>;
  storerocket_enabled_filters?: InputMaybe<String_Filter_Operators>;
  storerocket_filters?: InputMaybe<String_Filter_Operators>;
  translations?: InputMaybe<Settings_Translations_Filter>;
  translations_func?: InputMaybe<Count_Function_Filter_Operators>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type Settings_Translations = {
  __typename?: 'settings_translations';
  address?: Maybe<Scalars['String']>;
  buy_cta?: Maybe<Scalars['String']>;
  facebook_link?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  instagram_link?: Maybe<Scalars['String']>;
  languages_code?: Maybe<Languages>;
  logo?: Maybe<Directus_Files>;
  privacy_policy?: Maybe<Scalars['String']>;
  renspet_cta?: Maybe<Scalars['String']>;
  seo?: Maybe<Seo>;
  settings_id?: Maybe<Settings>;
  terms_and_conditions?: Maybe<Scalars['String']>;
};


export type Settings_TranslationsLanguages_CodeArgs = {
  filter?: InputMaybe<Languages_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Settings_TranslationsLogoArgs = {
  filter?: InputMaybe<Directus_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Settings_TranslationsSeoArgs = {
  filter?: InputMaybe<Seo_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Settings_TranslationsSettings_IdArgs = {
  filter?: InputMaybe<Settings_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Settings_Translations_Aggregated = {
  __typename?: 'settings_translations_aggregated';
  avg?: Maybe<Settings_Translations_Aggregated_Fields>;
  avgDistinct?: Maybe<Settings_Translations_Aggregated_Fields>;
  count?: Maybe<Settings_Translations_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Settings_Translations_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Settings_Translations_Aggregated_Fields>;
  min?: Maybe<Settings_Translations_Aggregated_Fields>;
  sum?: Maybe<Settings_Translations_Aggregated_Fields>;
  sumDistinct?: Maybe<Settings_Translations_Aggregated_Fields>;
};

export type Settings_Translations_Aggregated_Count = {
  __typename?: 'settings_translations_aggregated_count';
  address?: Maybe<Scalars['Int']>;
  buy_cta?: Maybe<Scalars['Int']>;
  facebook_link?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  instagram_link?: Maybe<Scalars['Int']>;
  languages_code?: Maybe<Scalars['Int']>;
  logo?: Maybe<Scalars['Int']>;
  privacy_policy?: Maybe<Scalars['Int']>;
  renspet_cta?: Maybe<Scalars['Int']>;
  seo?: Maybe<Scalars['Int']>;
  settings_id?: Maybe<Scalars['Int']>;
  terms_and_conditions?: Maybe<Scalars['Int']>;
};

export type Settings_Translations_Aggregated_Fields = {
  __typename?: 'settings_translations_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  settings_id?: Maybe<Scalars['Float']>;
};

export type Settings_Translations_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Settings_Translations_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Settings_Translations_Filter>>>;
  address?: InputMaybe<String_Filter_Operators>;
  buy_cta?: InputMaybe<String_Filter_Operators>;
  facebook_link?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<Number_Filter_Operators>;
  instagram_link?: InputMaybe<String_Filter_Operators>;
  languages_code?: InputMaybe<Languages_Filter>;
  logo?: InputMaybe<Directus_Files_Filter>;
  privacy_policy?: InputMaybe<String_Filter_Operators>;
  renspet_cta?: InputMaybe<String_Filter_Operators>;
  seo?: InputMaybe<Seo_Filter>;
  settings_id?: InputMaybe<Settings_Filter>;
  terms_and_conditions?: InputMaybe<String_Filter_Operators>;
};

export type Stories = {
  __typename?: 'stories';
  background_color?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  footnote?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  pet_name?: Maybe<Scalars['String']>;
  picture?: Maybe<Directus_Files>;
  sort?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Directus_Users>;
  user_updated?: Maybe<Directus_Users>;
};


export type StoriesPictureArgs = {
  filter?: InputMaybe<Directus_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type StoriesUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type StoriesUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Stories_Aggregated = {
  __typename?: 'stories_aggregated';
  avg?: Maybe<Stories_Aggregated_Fields>;
  avgDistinct?: Maybe<Stories_Aggregated_Fields>;
  count?: Maybe<Stories_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Stories_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Stories_Aggregated_Fields>;
  min?: Maybe<Stories_Aggregated_Fields>;
  sum?: Maybe<Stories_Aggregated_Fields>;
  sumDistinct?: Maybe<Stories_Aggregated_Fields>;
};

export type Stories_Aggregated_Count = {
  __typename?: 'stories_aggregated_count';
  background_color?: Maybe<Scalars['Int']>;
  content?: Maybe<Scalars['Int']>;
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  footnote?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  pet_name?: Maybe<Scalars['Int']>;
  picture?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
};

export type Stories_Aggregated_Fields = {
  __typename?: 'stories_aggregated_fields';
  sort?: Maybe<Scalars['Float']>;
};

export type Stories_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Stories_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Stories_Filter>>>;
  background_color?: InputMaybe<String_Filter_Operators>;
  content?: InputMaybe<String_Filter_Operators>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  footnote?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<String_Filter_Operators>;
  pet_name?: InputMaybe<String_Filter_Operators>;
  picture?: InputMaybe<Directus_Files_Filter>;
  sort?: InputMaybe<Number_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type String_Filter_Operators = {
  _contains?: InputMaybe<Scalars['String']>;
  _empty?: InputMaybe<Scalars['Boolean']>;
  _ends_with?: InputMaybe<Scalars['String']>;
  _eq?: InputMaybe<Scalars['String']>;
  _icontains?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  _ncontains?: InputMaybe<Scalars['String']>;
  _nempty?: InputMaybe<Scalars['Boolean']>;
  _nends_with?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  _nnull?: InputMaybe<Scalars['Boolean']>;
  _nstarts_with?: InputMaybe<Scalars['String']>;
  _null?: InputMaybe<Scalars['Boolean']>;
  _starts_with?: InputMaybe<Scalars['String']>;
};

export type Videos = {
  __typename?: 'videos';
  date_created?: Maybe<Scalars['Date']>;
  date_created_func?: Maybe<Datetime_Functions>;
  date_updated?: Maybe<Scalars['Date']>;
  date_updated_func?: Maybe<Datetime_Functions>;
  id: Scalars['ID'];
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<Videos_Translations>>>;
  translations_func?: Maybe<Count_Functions>;
  user_created?: Maybe<Directus_Users>;
  user_updated?: Maybe<Directus_Users>;
};


export type VideosTranslationsArgs = {
  filter?: InputMaybe<Videos_Translations_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type VideosUser_CreatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type VideosUser_UpdatedArgs = {
  filter?: InputMaybe<Directus_Users_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Videos_Aggregated = {
  __typename?: 'videos_aggregated';
  avg?: Maybe<Videos_Aggregated_Fields>;
  avgDistinct?: Maybe<Videos_Aggregated_Fields>;
  count?: Maybe<Videos_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Videos_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Videos_Aggregated_Fields>;
  min?: Maybe<Videos_Aggregated_Fields>;
  sum?: Maybe<Videos_Aggregated_Fields>;
  sumDistinct?: Maybe<Videos_Aggregated_Fields>;
};

export type Videos_Aggregated_Count = {
  __typename?: 'videos_aggregated_count';
  date_created?: Maybe<Scalars['Int']>;
  date_updated?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  translations?: Maybe<Scalars['Int']>;
  user_created?: Maybe<Scalars['Int']>;
  user_updated?: Maybe<Scalars['Int']>;
};

export type Videos_Aggregated_Fields = {
  __typename?: 'videos_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

export type Videos_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Videos_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Videos_Filter>>>;
  date_created?: InputMaybe<Date_Filter_Operators>;
  date_created_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  date_updated?: InputMaybe<Date_Filter_Operators>;
  date_updated_func?: InputMaybe<Datetime_Function_Filter_Operators>;
  id?: InputMaybe<Number_Filter_Operators>;
  sort?: InputMaybe<Number_Filter_Operators>;
  status?: InputMaybe<String_Filter_Operators>;
  translations?: InputMaybe<Videos_Translations_Filter>;
  translations_func?: InputMaybe<Count_Function_Filter_Operators>;
  user_created?: InputMaybe<Directus_Users_Filter>;
  user_updated?: InputMaybe<Directus_Users_Filter>;
};

export type Videos_Translations = {
  __typename?: 'videos_translations';
  external_link?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  languages_code?: Maybe<Languages>;
  thumbnail?: Maybe<Directus_Files>;
  title?: Maybe<Scalars['String']>;
  videos_id?: Maybe<Videos>;
};


export type Videos_TranslationsLanguages_CodeArgs = {
  filter?: InputMaybe<Languages_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Videos_TranslationsThumbnailArgs = {
  filter?: InputMaybe<Directus_Files_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type Videos_TranslationsVideos_IdArgs = {
  filter?: InputMaybe<Videos_Filter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Videos_Translations_Aggregated = {
  __typename?: 'videos_translations_aggregated';
  avg?: Maybe<Videos_Translations_Aggregated_Fields>;
  avgDistinct?: Maybe<Videos_Translations_Aggregated_Fields>;
  count?: Maybe<Videos_Translations_Aggregated_Count>;
  countAll?: Maybe<Scalars['Int']>;
  countDistinct?: Maybe<Videos_Translations_Aggregated_Count>;
  group?: Maybe<Scalars['JSON']>;
  max?: Maybe<Videos_Translations_Aggregated_Fields>;
  min?: Maybe<Videos_Translations_Aggregated_Fields>;
  sum?: Maybe<Videos_Translations_Aggregated_Fields>;
  sumDistinct?: Maybe<Videos_Translations_Aggregated_Fields>;
};

export type Videos_Translations_Aggregated_Count = {
  __typename?: 'videos_translations_aggregated_count';
  external_link?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  languages_code?: Maybe<Scalars['Int']>;
  thumbnail?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['Int']>;
  videos_id?: Maybe<Scalars['Int']>;
};

export type Videos_Translations_Aggregated_Fields = {
  __typename?: 'videos_translations_aggregated_fields';
  id?: Maybe<Scalars['Float']>;
  videos_id?: Maybe<Scalars['Float']>;
};

export type Videos_Translations_Filter = {
  _and?: InputMaybe<Array<InputMaybe<Videos_Translations_Filter>>>;
  _or?: InputMaybe<Array<InputMaybe<Videos_Translations_Filter>>>;
  external_link?: InputMaybe<String_Filter_Operators>;
  id?: InputMaybe<Number_Filter_Operators>;
  languages_code?: InputMaybe<Languages_Filter>;
  thumbnail?: InputMaybe<Directus_Files_Filter>;
  title?: InputMaybe<String_Filter_Operators>;
  videos_id?: InputMaybe<Videos_Filter>;
};

export type AnimalArchivePageQueryVariables = Exact<{
  lang?: InputMaybe<Scalars['String']>;
  animalType?: InputMaybe<Scalars['String']>;
}>;


export type AnimalArchivePageQuery = { __typename?: 'Query', animals: Array<{ __typename?: 'animals', translations?: Array<{ __typename?: 'animals_translations', title?: string | null, friendly_title?: string | null } | null> | null }>, pages: Array<{ __typename?: 'pages', colorScheme?: { __typename?: 'color_schemes', background?: string | null, accent?: string | null, title?: string | null } | null, translations?: Array<{ __typename?: 'pages_translations', seo?: (
        { __typename?: 'seo' }
        & { ' $fragmentRefs'?: { 'SeoContentFragment': SeoContentFragment } }
      ) | null } | null> | null }> };

export type ArticleQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  lang?: InputMaybe<Scalars['String']>;
}>;


export type ArticleQuery = { __typename?: 'Query', articles: Array<{ __typename?: 'articles', id: string, publicationDate?: any | null, translations?: Array<{ __typename?: 'articles_translations', title?: string | null, content?: string | null, featuredImage?: { __typename?: 'directus_files', id: string, width?: number | null, height?: number | null, description?: string | null, filenameDownload: string } | null, seo?: (
        { __typename?: 'seo' }
        & { ' $fragmentRefs'?: { 'SeoContentFragment': SeoContentFragment } }
      ) | null } | null> | null, featuredImage?: { __typename?: 'directus_files', id: string, width?: number | null, height?: number | null, description?: string | null, filenameDownload: string } | null }> };

export type ArticlesArchivePageQueryVariables = Exact<{
  lang?: InputMaybe<Scalars['String']>;
}>;


export type ArticlesArchivePageQuery = { __typename?: 'Query', pages: Array<{ __typename?: 'pages', colorScheme?: { __typename?: 'color_schemes', title?: string | null, accent?: string | null, background?: string | null } | null, parent?: { __typename?: 'pages', translations?: Array<{ __typename?: 'pages_translations', slug: string, title: string } | null> | null } | null, translations?: Array<{ __typename?: 'pages_translations', title: string, heading?: string | null, seo?: (
        { __typename?: 'seo' }
        & { ' $fragmentRefs'?: { 'SeoContentFragment': SeoContentFragment } }
      ) | null } | null> | null }> };

export type ArticlesQueryVariables = Exact<{
  lang?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type ArticlesQuery = { __typename?: 'Query', articles: Array<{ __typename?: 'articles', id: string, translations?: Array<{ __typename?: 'articles_translations', title?: string | null, content?: string | null, slug: string, excerpt?: string | null, featuredImage?: { __typename?: 'directus_files', id: string, width?: number | null, height?: number | null, description?: string | null, filenameDownload: string } | null } | null> | null, featuredImage?: { __typename?: 'directus_files', id: string, width?: number | null, height?: number | null, description?: string | null, filenameDownload: string } | null }> };

export type LottieQueryVariables = Exact<{
  filename?: InputMaybe<Scalars['String']>;
}>;


export type LottieQuery = { __typename?: 'Query', animations: Array<{ __typename?: 'animations', id: string, typename: 'animations', animal?: { __typename?: 'animals', id: string } | null, lottie?: { __typename?: 'directus_files', id: string, filename: string } | null }> };

export type AnimationsQueryVariables = Exact<{
  forProductGrid?: InputMaybe<Scalars['Boolean']>;
  lang?: InputMaybe<Scalars['String']>;
}>;


export type AnimationsQuery = { __typename?: 'Query', animations: Array<{ __typename?: 'animations', id: string, typename: 'animations', animal?: { __typename?: 'animals', id: string } | null, lottieFile?: { __typename?: 'directus_files', id: string, filenameDownload: string } | null }> };

export type ProductsQueryVariables = Exact<{
  lang?: InputMaybe<Scalars['String']>;
  animalType?: InputMaybe<Scalars['String']>;
}>;


export type ProductsQuery = { __typename?: 'Query', productTypes: Array<{ __typename?: 'product_types', id: string, translations?: Array<{ __typename?: 'product_types_translations', title?: string | null } | null> | null, availableFacets?: Array<{ __typename?: 'product_types_product_facets', productFacetsId?: { __typename?: 'product_facets', options?: Array<{ __typename?: 'product_facets_item', id: string, translations?: Array<{ __typename?: 'product_facets_item_translations', name?: string | null } | null> | null } | null> | null } | null } | null> | null, products?: Array<{ __typename?: 'products', id: string, typename: 'products', colors?: { __typename?: 'color_schemes', background?: string | null } | null, featuredImage?: { __typename?: 'directus_files', id: string, width?: number | null, height?: number | null, filenameDownload: string } | null, animals?: { __typename?: 'animals', id: string, color?: string | null, translations?: Array<{ __typename?: 'animals_translations', title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'products_translations', id: string, sizes?: string | null, subtitle?: string | null, title?: string | null, slug?: string | null } | null> | null, facetOptions?: Array<{ __typename?: 'products_product_facets_item', productFacetsItemId?: { __typename?: 'product_facets_item', id: string } | null } | null> | null } | null> | null }> };

export type VideosQueryVariables = Exact<{
  lang?: InputMaybe<Scalars['String']>;
}>;


export type VideosQuery = { __typename?: 'Query', videos: Array<{ __typename?: 'videos', id: string, translations?: Array<{ __typename?: 'videos_translations', title?: string | null, externalLink?: string | null, thumbnail?: { __typename?: 'directus_files', description?: string | null, id: string, filenameDownload: string } | null } | null> | null }> };

export type HomeQueryVariables = Exact<{
  lang?: InputMaybe<Scalars['String']>;
}>;


export type HomeQuery = { __typename?: 'Query', pages: Array<{ __typename?: 'pages', friendly_id?: string | null, translations?: Array<{ __typename?: 'pages_translations', title: string, sections?: Array<(
        { __typename?: 'pages_translations_sections' }
        & { ' $fragmentRefs'?: { 'PageSectionsFragment': PageSectionsFragment } }
      ) | null> | null, seo?: (
        { __typename?: 'seo' }
        & { ' $fragmentRefs'?: { 'SeoContentFragment': SeoContentFragment } }
      ) | null } | null> | null, colorScheme?: (
      { __typename?: 'color_schemes' }
      & { ' $fragmentRefs'?: { 'ColorSchemeFragment': ColorSchemeFragment } }
    ) | null }> };

export type NavigationsQueryVariables = Exact<{
  loc?: InputMaybe<Scalars['String']>;
  lang?: InputMaybe<Scalars['String']>;
}>;


export type NavigationsQuery = { __typename?: 'Query', navigations: Array<{ __typename?: 'navigations', date_created?: any | null, frTranslations?: Array<{ __typename?: 'navigations_translations', items?: Array<{ __typename?: 'navigation_items', title: string } | null> | null } | null> | null, translations?: Array<{ __typename?: 'navigations_translations', items?: Array<{ __typename?: 'navigation_items', id: string, has_children: boolean, title: string, path?: string | null, children?: Array<{ __typename?: 'navigation_items', id: string, title: string, path?: string | null } | null> | null, page?: { __typename?: 'pages', translations?: Array<{ __typename?: 'pages_translations', title: string, slug: string } | null> | null } | null } | null> | null } | null> | null }> };

export type PetParentsCornerPageQueryVariables = Exact<{
  lang?: InputMaybe<Scalars['String']>;
}>;


export type PetParentsCornerPageQuery = { __typename?: 'Query', pages: Array<{ __typename?: 'pages', friendlyId?: string | null, colorScheme?: (
      { __typename?: 'color_schemes' }
      & { ' $fragmentRefs'?: { 'ColorSchemeFragment': ColorSchemeFragment } }
    ) | null, frTranslations?: Array<{ __typename?: 'pages_translations', title: string, slug: string, id: string, sections?: Array<(
        { __typename?: 'pages_translations_sections', id: string, collection?: string | null }
        & { ' $fragmentRefs'?: { 'PageSectionsFragment': PageSectionsFragment } }
      ) | null> | null } | null> | null, translations?: Array<{ __typename?: 'pages_translations', title: string, slug: string, id: string, sections?: Array<(
        { __typename?: 'pages_translations_sections', id: string, collection?: string | null }
        & { ' $fragmentRefs'?: { 'PageSectionsFragment': PageSectionsFragment } }
      ) | null> | null, seo?: (
        { __typename?: 'seo' }
        & { ' $fragmentRefs'?: { 'SeoContentFragment': SeoContentFragment } }
      ) | null } | null> | null }> };

export type ProductAnimalIdQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type ProductAnimalIdQuery = { __typename?: 'Query', products: Array<{ __typename?: 'products', animals?: { __typename?: 'animals', id: string } | null }> };

export type SlugInOtherLanguageQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  lang?: InputMaybe<Scalars['String']>;
}>;


export type SlugInOtherLanguageQuery = { __typename?: 'Query', products: Array<{ __typename?: 'products', translations?: Array<{ __typename?: 'products_translations', slug?: string | null } | null> | null }> };

export type ProductQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
  animalId?: InputMaybe<Scalars['String']>;
  lang?: InputMaybe<Scalars['String']>;
}>;


export type ProductQuery = { __typename?: 'Query', products: Array<{ __typename?: 'products', id: string, animals?: { __typename?: 'animals', id: string, translations?: Array<{ __typename?: 'animals_translations', title?: string | null } | null> | null } | null, facet_options?: Array<{ __typename?: 'products_product_facets_item', product_facets_item_id?: { __typename?: 'product_facets_item', translations?: Array<{ __typename?: 'product_facets_item_translations', name?: string | null } | null> | null, parent?: { __typename?: 'product_facets', id: string } | null } | null } | null> | null, flavorIcon?: { __typename?: 'directus_files', id: string, width?: number | null, height?: number | null, filenameDownload: string } | null, colorScheme?: { __typename?: 'color_schemes', background?: string | null, accent?: string | null, title?: string | null, outline?: string | null, accentMuted?: string | null, backgroundMuted?: string | null } | null, backgroundPattern?: { __typename?: 'directus_files', id: string, width?: number | null, height?: number | null, filenameDownload: string } | null, featuredImage?: { __typename?: 'directus_files', id: string, width?: number | null, height?: number | null, description?: string | null, filenameDownload: string } | null, additionalImages?: Array<{ __typename?: 'products_files_1', directusFilesId?: { __typename?: 'directus_files', id: string, width?: number | null, height?: number | null, description?: string | null, filenameDownload: string } | null } | null> | null, animation?: { __typename?: 'animations', lottieFile?: { __typename?: 'directus_files', id: string, filenameDownload: string } | null } | null, translations?: Array<{ __typename?: 'products_translations', title?: string | null, slug?: string | null, ingredients?: string | null, subtitle?: string | null, description?: string | null, sizes?: string | null, flavor?: string | null, ressources?: string | null, claims?: string | null, specifications?: string | null, caloryContent?: string | null, feedingGuideline?: string | null, guaranteedAnalysis?: string | null, buyCta?: string | null, renCta?: string | null, seo?: (
        { __typename?: 'seo' }
        & { ' $fragmentRefs'?: { 'SeoContentFragment': SeoContentFragment } }
      ) | null } | null> | null, product_type?: { __typename?: 'product_types', id: string, products?: Array<{ __typename?: 'products', facet_options?: Array<{ __typename?: 'products_product_facets_item', product_facets_item_id?: { __typename?: 'product_facets_item', translations?: Array<{ __typename?: 'product_facets_item_translations', name?: string | null } | null> | null, parent?: { __typename?: 'product_facets', id: string } | null } | null } | null> | null, frTranslations?: Array<{ __typename?: 'products_translations', title?: string | null, flavor?: string | null, slug?: string | null, id: string } | null> | null, translations?: Array<{ __typename?: 'products_translations', title?: string | null, flavor?: string | null, slug?: string | null, id: string } | null> | null, flavorIcon?: { __typename?: 'directus_files', description?: string | null, title?: string | null, id: string, width?: number | null, height?: number | null, filenameDownload: string } | null, animals?: { __typename?: 'animals', translations?: Array<{ __typename?: 'animals_translations', title?: string | null } | null> | null } | null } | null> | null } | null, claims?: Array<{ __typename?: 'products_claims', id: string, claimsId?: { __typename?: 'claims', icon?: { __typename?: 'directus_files', description?: string | null, title?: string | null, id: string, width?: number | null, height?: number | null, filenameDownload: string } | null, translations?: Array<{ __typename?: 'claims_translations', content?: string | null } | null> | null } | null } | null> | null, recommendations?: { __typename?: 'recommendations', recommendedProducts?: Array<{ __typename?: 'recommendations_products', productsId?: { __typename?: 'products', id: string, typename: 'products', colors?: { __typename?: 'color_schemes', background?: string | null } | null, featuredImage?: { __typename?: 'directus_files', id: string, width?: number | null, height?: number | null, filenameDownload: string } | null, animals?: { __typename?: 'animals', id: string, color?: string | null, translations?: Array<{ __typename?: 'animals_translations', title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'products_translations', id: string, sizes?: string | null, subtitle?: string | null, title?: string | null, slug?: string | null } | null> | null, facetOptions?: Array<{ __typename?: 'products_product_facets_item', productFacetsItemId?: { __typename?: 'product_facets_item', id: string } | null } | null> | null } | null } | null> | null } | null }> };

export type ProductsArchivePageQueryVariables = Exact<{
  lang?: InputMaybe<Scalars['String']>;
}>;


export type ProductsArchivePageQuery = { __typename?: 'Query', pages: Array<{ __typename?: 'pages', colorScheme?: { __typename?: 'color_schemes', title?: string | null, accent?: string | null, background?: string | null } | null, translations?: Array<{ __typename?: 'pages_translations', title: string, seo?: (
        { __typename?: 'seo' }
        & { ' $fragmentRefs'?: { 'SeoContentFragment': SeoContentFragment } }
      ) | null } | null> | null }> };

export type ProductsSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  lang?: InputMaybe<Scalars['String']>;
}>;


export type ProductsSearchQuery = { __typename?: 'Query', productsTranslations: Array<{ __typename?: 'products_translations', title?: string | null, product?: { __typename?: 'products', id: string, colors?: { __typename?: 'color_schemes', background?: string | null } | null, featuredImage?: { __typename?: 'directus_files', id: string, width?: number | null, height?: number | null, filenameDownload: string } | null, animals?: { __typename?: 'animals', id: string, color?: string | null, translations?: Array<{ __typename?: 'animals_translations', title?: string | null } | null> | null } | null, translations?: Array<{ __typename?: 'products_translations', id: string, sizes?: string | null, subtitle?: string | null, title?: string | null, slug?: string | null } | null> | null } | null }> };

export type SeoContentFragment = { __typename?: 'seo', title?: string | null, description?: string | null, thumbnail?: { __typename?: 'directus_files', id: string, filename_download: string, width?: number | null, height?: number | null, type?: string | null, description?: string | null } | null } & { ' $fragmentName'?: 'SeoContentFragment' };

export type SettingsQueryVariables = Exact<{
  lang?: InputMaybe<Scalars['String']>;
}>;


export type SettingsQuery = { __typename?: 'Query', settings?: { __typename?: 'settings', storeRocketAccountId?: string | null, storeRocketEnabledFilters?: string | null, storeRocketFilters?: string | null, translations?: Array<{ __typename?: 'settings_translations', address?: string | null, facebookLink?: string | null, instagramLink?: string | null, privacyPolicy?: string | null, termsAndCondition?: string | null, buyCta?: string | null, renCta?: string | null, seo?: (
        { __typename?: 'seo' }
        & { ' $fragmentRefs'?: { 'SeoContentFragment': SeoContentFragment } }
      ) | null } | null> | null, mondou_logo?: { __typename?: 'directus_files', id: string, filename_download: string, description?: string | null } | null, renspet_logo?: { __typename?: 'directus_files', id: string, filename_download: string, description?: string | null } | null } | null };

export type BlockContentFragment = { __typename?: 'block_content', title?: string | null, id: string, content?: string | null, colors?: (
    { __typename?: 'color_schemes' }
    & { ' $fragmentRefs'?: { 'ColorSchemeFragment': ColorSchemeFragment } }
  ) | null } & { ' $fragmentName'?: 'BlockContentFragment' };

export type BlockFaqFragment = { __typename?: 'block_faq', id: string, title?: string | null, qnaList?: any | null, colors?: (
    { __typename?: 'color_schemes' }
    & { ' $fragmentRefs'?: { 'ColorSchemeFragment': ColorSchemeFragment } }
  ) | null } & { ' $fragmentName'?: 'BlockFaqFragment' };

export type BlockMdxFragment = { __typename?: 'block_mdx', id: string, title?: string | null, content?: string | null } & { ' $fragmentName'?: 'BlockMdxFragment' };

export type BlockContestFragment = { __typename?: 'block_contest', title?: string | null, content?: string | null, colors?: (
    { __typename?: 'color_schemes' }
    & { ' $fragmentRefs'?: { 'ColorSchemeFragment': ColorSchemeFragment } }
  ) | null, featured_image?: { __typename?: 'directus_files', id: string, width?: number | null, height?: number | null, description?: string | null, filenameDownload: string } | null } & { ' $fragmentName'?: 'BlockContestFragment' };

export type BlockStoriesFragment = { __typename?: 'block_stories', title?: string | null, colors?: (
    { __typename?: 'color_schemes' }
    & { ' $fragmentRefs'?: { 'ColorSchemeFragment': ColorSchemeFragment } }
  ) | null, stories?: Array<{ __typename?: 'block_stories_stories', id: string, storiesId?: { __typename?: 'stories', id: string, footnote?: string | null, content?: string | null, backgroundColor?: string | null, petName?: string | null, picture?: { __typename?: 'directus_files', id: string, description?: string | null, filenameDownload: string } | null } | null } | null> | null } & { ' $fragmentName'?: 'BlockStoriesFragment' };

export type PageSectionsFragment = { __typename?: 'pages_translations_sections', id: string, item?: (
    { __typename?: 'block_content', shortTitle?: string | null, friendlyId?: string | null, isAnchored?: boolean | null, type: 'block_content' }
    & { ' $fragmentRefs'?: { 'BlockContentFragment': BlockContentFragment } }
  ) | (
    { __typename?: 'block_contest', isAnchored?: boolean | null, shortTitle?: string | null, friendlyId?: string | null, type: 'block_contest' }
    & { ' $fragmentRefs'?: { 'BlockContestFragment': BlockContestFragment } }
  ) | (
    { __typename?: 'block_faq', isAnchored?: boolean | null, shortTitle?: string | null, type: 'block_faq' }
    & { ' $fragmentRefs'?: { 'BlockFaqFragment': BlockFaqFragment } }
  ) | (
    { __typename?: 'block_mdx', isAnchored?: boolean | null, shortTitle?: string | null, title?: string | null, friendlyId?: string | null, type: 'block_mdx' }
    & { ' $fragmentRefs'?: { 'BlockMdxFragment': BlockMdxFragment } }
  ) | (
    { __typename?: 'block_stories', isAnchored?: boolean | null, shortTitle?: string | null, friendlyId?: string | null, type: 'block_stories' }
    & { ' $fragmentRefs'?: { 'BlockStoriesFragment': BlockStoriesFragment } }
  ) | null } & { ' $fragmentName'?: 'PageSectionsFragment' };

export type ColorSchemeFragment = { __typename?: 'color_schemes', title?: string | null, accent?: string | null, background?: string | null, outline?: string | null, backgroundMuted?: string | null, accentMuted?: string | null } & { ' $fragmentName'?: 'ColorSchemeFragment' };

export type SinglePageSlugInOtherLanguageQueryVariables = Exact<{
  uri?: InputMaybe<Scalars['String']>;
  lang?: InputMaybe<Scalars['String']>;
}>;


export type SinglePageSlugInOtherLanguageQuery = { __typename?: 'Query', pages: Array<{ __typename?: 'pages', translations?: Array<{ __typename?: 'pages_translations', slug: string } | null> | null }> };

export type SinglePageQueryVariables = Exact<{
  lang?: InputMaybe<Scalars['String']>;
  uri?: InputMaybe<Scalars['String']>;
}>;


export type SinglePageQuery = { __typename?: 'Query', pages: Array<{ __typename?: 'pages', friendlyId?: string | null, parent?: { __typename?: 'pages', translations?: Array<{ __typename?: 'pages_translations', slug: string, title: string } | null> | null } | null, colorScheme?: (
      { __typename?: 'color_schemes' }
      & { ' $fragmentRefs'?: { 'ColorSchemeFragment': ColorSchemeFragment } }
    ) | null, frTranslations?: Array<{ __typename?: 'pages_translations', title: string, slug: string, id: string, heading?: string | null, sections?: Array<(
        { __typename?: 'pages_translations_sections', collection?: string | null }
        & { ' $fragmentRefs'?: { 'PageSectionsFragment': PageSectionsFragment } }
      ) | null> | null } | null> | null, translations?: Array<{ __typename?: 'pages_translations', title: string, slug: string, id: string, heading?: string | null, sections?: Array<(
        { __typename?: 'pages_translations_sections', collection?: string | null }
        & { ' $fragmentRefs'?: { 'PageSectionsFragment': PageSectionsFragment } }
      ) | null> | null, seo?: (
        { __typename?: 'seo' }
        & { ' $fragmentRefs'?: { 'SeoContentFragment': SeoContentFragment } }
      ) | null } | null> | null }> };

export type PagesQueryVariables = Exact<{ [key: string]: never; }>;


export type PagesQuery = { __typename?: 'Query', animals: Array<{ __typename?: 'animals', date_updated?: any | null, translations?: Array<{ __typename?: 'animals_translations', friendly_title?: string | null, languages_code?: { __typename?: 'languages', code: string } | null } | null> | null, products?: Array<{ __typename?: 'products', date_updated?: any | null, animals?: { __typename?: 'animals', translations?: Array<{ __typename?: 'animals_translations', friendly_title?: string | null, languages_code?: { __typename?: 'languages', code: string } | null } | null> | null } | null, translations?: Array<{ __typename?: 'products_translations', slug?: string | null, languages_code?: { __typename?: 'languages', code: string } | null } | null> | null } | null> | null }>, articles: Array<{ __typename?: 'articles', date_updated?: any | null, translations?: Array<{ __typename?: 'articles_translations', title?: string | null, slug: string, languages_code?: { __typename?: 'languages', code: string } | null } | null> | null }>, pages: Array<{ __typename?: 'pages', date_updated?: any | null, translations?: Array<{ __typename?: 'pages_translations', slug: string, languages_code?: { __typename?: 'languages', code: string } | null } | null> | null }> };

export type WhereToFindUsQueryVariables = Exact<{
  lang?: InputMaybe<Scalars['String']>;
}>;


export type WhereToFindUsQuery = { __typename?: 'Query', pages: Array<{ __typename?: 'pages', translations?: Array<{ __typename?: 'pages_translations', title: string, heading?: string | null, slug: string, id: string, sections?: Array<(
        { __typename?: 'pages_translations_sections', collection?: string | null }
        & { ' $fragmentRefs'?: { 'PageSectionsFragment': PageSectionsFragment } }
      ) | null> | null, seo?: (
        { __typename?: 'seo' }
        & { ' $fragmentRefs'?: { 'SeoContentFragment': SeoContentFragment } }
      ) | null } | null> | null, colorScheme?: (
      { __typename?: 'color_schemes' }
      & { ' $fragmentRefs'?: { 'ColorSchemeFragment': ColorSchemeFragment } }
    ) | null }> };

export const SeoContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SeoContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"seo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<SeoContentFragment, unknown>;
export const ColorSchemeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ColorScheme"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"color_schemes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"accent"}},{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"outline"}},{"kind":"Field","alias":{"kind":"Name","value":"backgroundMuted"},"name":{"kind":"Name","value":"background_muted"}},{"kind":"Field","alias":{"kind":"Name","value":"accentMuted"},"name":{"kind":"Name","value":"accent_muted"}}]}}]} as unknown as DocumentNode<ColorSchemeFragment, unknown>;
export const BlockContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ColorScheme"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"color_schemes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"accent"}},{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"outline"}},{"kind":"Field","alias":{"kind":"Name","value":"backgroundMuted"},"name":{"kind":"Name","value":"background_muted"}},{"kind":"Field","alias":{"kind":"Name","value":"accentMuted"},"name":{"kind":"Name","value":"accent_muted"}}]}}]} as unknown as DocumentNode<BlockContentFragment, unknown>;
export const BlockFaqFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockFaq"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_faq"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"qnaList"},"name":{"kind":"Name","value":"qna_list"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ColorScheme"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"color_schemes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"accent"}},{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"outline"}},{"kind":"Field","alias":{"kind":"Name","value":"backgroundMuted"},"name":{"kind":"Name","value":"background_muted"}},{"kind":"Field","alias":{"kind":"Name","value":"accentMuted"},"name":{"kind":"Name","value":"accent_muted"}}]}}]} as unknown as DocumentNode<BlockFaqFragment, unknown>;
export const BlockMdxFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockMdx"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_mdx"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]} as unknown as DocumentNode<BlockMdxFragment, unknown>;
export const BlockStoriesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockStories"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_stories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"storiesId"},"name":{"kind":"Name","value":"stories_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"backgroundColor"},"name":{"kind":"Name","value":"background_color"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"footnote"}},{"kind":"Field","alias":{"kind":"Name","value":"petName"},"name":{"kind":"Name","value":"pet_name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ColorScheme"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"color_schemes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"accent"}},{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"outline"}},{"kind":"Field","alias":{"kind":"Name","value":"backgroundMuted"},"name":{"kind":"Name","value":"background_muted"}},{"kind":"Field","alias":{"kind":"Name","value":"accentMuted"},"name":{"kind":"Name","value":"accent_muted"}}]}}]} as unknown as DocumentNode<BlockStoriesFragment, unknown>;
export const BlockContestFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockContest"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_contest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}},{"kind":"Field","name":{"kind":"Name","value":"featured_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ColorScheme"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"color_schemes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"accent"}},{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"outline"}},{"kind":"Field","alias":{"kind":"Name","value":"backgroundMuted"},"name":{"kind":"Name","value":"background_muted"}},{"kind":"Field","alias":{"kind":"Name","value":"accentMuted"},"name":{"kind":"Name","value":"accent_muted"}}]}}]} as unknown as DocumentNode<BlockContestFragment, unknown>;
export const PageSectionsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageSections"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pages_translations_sections"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"Field","alias":{"kind":"Name","value":"friendlyId"},"name":{"kind":"Name","value":"friendly_id"}},{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockContent"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_faq"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockFaq"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_mdx"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"friendlyId"},"name":{"kind":"Name","value":"friendly_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockMdx"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_stories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"Field","alias":{"kind":"Name","value":"friendlyId"},"name":{"kind":"Name","value":"friendly_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockStories"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_contest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"Field","alias":{"kind":"Name","value":"friendlyId"},"name":{"kind":"Name","value":"friendly_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockContest"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ColorScheme"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"color_schemes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"accent"}},{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"outline"}},{"kind":"Field","alias":{"kind":"Name","value":"backgroundMuted"},"name":{"kind":"Name","value":"background_muted"}},{"kind":"Field","alias":{"kind":"Name","value":"accentMuted"},"name":{"kind":"Name","value":"accent_muted"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockFaq"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_faq"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"qnaList"},"name":{"kind":"Name","value":"qna_list"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockMdx"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_mdx"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockStories"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_stories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"storiesId"},"name":{"kind":"Name","value":"stories_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"backgroundColor"},"name":{"kind":"Name","value":"background_color"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"footnote"}},{"kind":"Field","alias":{"kind":"Name","value":"petName"},"name":{"kind":"Name","value":"pet_name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockContest"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_contest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}},{"kind":"Field","name":{"kind":"Name","value":"featured_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<PageSectionsFragment, unknown>;
export const AnimalArchivePageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"animalArchivePage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"animalType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"animals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"animalType"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"friendly_title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"friendly_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"products-archive","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"colorScheme"},"name":{"kind":"Name","value":"color_scheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"accent"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SeoContent"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SeoContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"seo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<AnimalArchivePageQuery, AnimalArchivePageQueryVariables>;
export const ArticleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Article"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"translations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"published","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"publicationDate"},"name":{"kind":"Name","value":"publication_date"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","alias":{"kind":"Name","value":"featuredImage"},"name":{"kind":"Name","value":"featured_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SeoContent"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"featuredImage"},"name":{"kind":"Name","value":"featured_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SeoContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"seo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<ArticleQuery, ArticleQueryVariables>;
export const ArticlesArchivePageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArticlesArchivePage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"friendly_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"articles-archive","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"colorScheme"},"name":{"kind":"Name","value":"color_scheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"accent"}},{"kind":"Field","name":{"kind":"Name","value":"background"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SeoContent"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SeoContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"seo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<ArticlesArchivePageQuery, ArticlesArchivePageQueryVariables>;
export const ArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Articles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"published","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"sort","block":false},{"kind":"StringValue","value":"-publication_date","block":false}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"excerpt"}},{"kind":"Field","alias":{"kind":"Name","value":"featuredImage"},"name":{"kind":"Name","value":"featured_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"featuredImage"},"name":{"kind":"Name","value":"featured_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<ArticlesQuery, ArticlesQueryVariables>;
export const LottieDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"lottie"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filename"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"animations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lottie_file"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"filename_download"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filename"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"typename"},"name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"animal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lottie"},"name":{"kind":"Name","value":"lottie_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"filename"},"name":{"kind":"Name","value":"filename_download"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<LottieQuery, LottieQueryVariables>;
export const AnimationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"animations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"forProductGrid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"animations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"show_on_product_grid"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"forProductGrid"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"language"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"language"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_null"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"typename"},"name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"animal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lottieFile"},"name":{"kind":"Name","value":"lottie_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}}]}}]}}]}}]} as unknown as DocumentNode<AnimationsQuery, AnimationsQueryVariables>;
export const ProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"products"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"animalType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"productTypes"},"name":{"kind":"Name","value":"product_types"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"availableFacets"},"name":{"kind":"Name","value":"available_facets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"productFacetsId"},"name":{"kind":"Name","value":"product_facets_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"animals"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"animalType"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"StringValue","value":"sort","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"typename"},"name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"colors"},"name":{"kind":"Name","value":"color_scheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"featuredImage"},"name":{"kind":"Name","value":"featured_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"animals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"facetOptions"},"name":{"kind":"Name","value":"facet_options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"productFacetsItemId"},"name":{"kind":"Name","value":"product_facets_item_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductsQuery, ProductsQueryVariables>;
export const VideosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"videos"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"externalLink"},"name":{"kind":"Name","value":"external_link"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<VideosQuery, VideosQueryVariables>;
export const HomeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"home"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"friendly_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"home","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"friendly_id"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageSections"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SeoContent"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"colorScheme"},"name":{"kind":"Name","value":"color_scheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ColorScheme"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"color_schemes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"accent"}},{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"outline"}},{"kind":"Field","alias":{"kind":"Name","value":"backgroundMuted"},"name":{"kind":"Name","value":"background_muted"}},{"kind":"Field","alias":{"kind":"Name","value":"accentMuted"},"name":{"kind":"Name","value":"accent_muted"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockFaq"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_faq"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"qnaList"},"name":{"kind":"Name","value":"qna_list"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockMdx"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_mdx"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockStories"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_stories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"storiesId"},"name":{"kind":"Name","value":"stories_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"backgroundColor"},"name":{"kind":"Name","value":"background_color"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"footnote"}},{"kind":"Field","alias":{"kind":"Name","value":"petName"},"name":{"kind":"Name","value":"pet_name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockContest"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_contest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}},{"kind":"Field","name":{"kind":"Name","value":"featured_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageSections"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pages_translations_sections"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"Field","alias":{"kind":"Name","value":"friendlyId"},"name":{"kind":"Name","value":"friendly_id"}},{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockContent"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_faq"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockFaq"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_mdx"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"friendlyId"},"name":{"kind":"Name","value":"friendly_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockMdx"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_stories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"Field","alias":{"kind":"Name","value":"friendlyId"},"name":{"kind":"Name","value":"friendly_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockStories"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_contest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"Field","alias":{"kind":"Name","value":"friendlyId"},"name":{"kind":"Name","value":"friendly_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockContest"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SeoContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"seo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<HomeQuery, HomeQueryVariables>;
export const NavigationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Navigations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loc"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"location"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loc"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date_created"}},{"kind":"Field","alias":{"kind":"Name","value":"frTranslations"},"name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"fr-FR","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"has_children"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}},{"kind":"Field","name":{"kind":"Name","value":"page"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NavigationsQuery, NavigationsQueryVariables>;
export const PetParentsCornerPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PetParentsCornerPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"friendly_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"pet-parents-corner","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"friendlyId"},"name":{"kind":"Name","value":"friendly_id"}},{"kind":"Field","alias":{"kind":"Name","value":"colorScheme"},"name":{"kind":"Name","value":"color_scheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"frTranslations"},"name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"fr-FR","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"collection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageSections"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"collection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageSections"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SeoContent"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ColorScheme"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"color_schemes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"accent"}},{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"outline"}},{"kind":"Field","alias":{"kind":"Name","value":"backgroundMuted"},"name":{"kind":"Name","value":"background_muted"}},{"kind":"Field","alias":{"kind":"Name","value":"accentMuted"},"name":{"kind":"Name","value":"accent_muted"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockFaq"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_faq"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"qnaList"},"name":{"kind":"Name","value":"qna_list"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockMdx"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_mdx"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockStories"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_stories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"storiesId"},"name":{"kind":"Name","value":"stories_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"backgroundColor"},"name":{"kind":"Name","value":"background_color"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"footnote"}},{"kind":"Field","alias":{"kind":"Name","value":"petName"},"name":{"kind":"Name","value":"pet_name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockContest"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_contest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}},{"kind":"Field","name":{"kind":"Name","value":"featured_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageSections"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pages_translations_sections"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"Field","alias":{"kind":"Name","value":"friendlyId"},"name":{"kind":"Name","value":"friendly_id"}},{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockContent"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_faq"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockFaq"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_mdx"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"friendlyId"},"name":{"kind":"Name","value":"friendly_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockMdx"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_stories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"Field","alias":{"kind":"Name","value":"friendlyId"},"name":{"kind":"Name","value":"friendly_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockStories"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_contest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"Field","alias":{"kind":"Name","value":"friendlyId"},"name":{"kind":"Name","value":"friendly_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockContest"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SeoContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"seo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<PetParentsCornerPageQuery, PetParentsCornerPageQueryVariables>;
export const ProductAnimalIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductAnimalId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"translations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"animals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ProductAnimalIdQuery, ProductAnimalIdQueryVariables>;
export const SlugInOtherLanguageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SlugInOtherLanguage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"translations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<SlugInOtherLanguageQuery, SlugInOtherLanguageQueryVariables>;
export const ProductDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Product"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"animalId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"fr","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"translations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"animals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"facet_options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_facets_item_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flavorIcon"},"name":{"kind":"Name","value":"flavor_icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"colorScheme"},"name":{"kind":"Name","value":"color_scheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"accent"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"accentMuted"},"name":{"kind":"Name","value":"accent_muted"}},{"kind":"Field","alias":{"kind":"Name","value":"backgroundMuted"},"name":{"kind":"Name","value":"background_muted"}},{"kind":"Field","name":{"kind":"Name","value":"outline"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"backgroundPattern"},"name":{"kind":"Name","value":"background_pattern"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"featuredImage"},"name":{"kind":"Name","value":"featured_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"additionalImages"},"name":{"kind":"Name","value":"additional_images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"directusFilesId"},"name":{"kind":"Name","value":"directus_files_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"animation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lottieFile"},"name":{"kind":"Name","value":"lottie_file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"ingredients"}},{"kind":"Field","alias":{"kind":"Name","value":"caloryContent"},"name":{"kind":"Name","value":"calory_content"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"flavor"}},{"kind":"Field","alias":{"kind":"Name","value":"feedingGuideline"},"name":{"kind":"Name","value":"feeding_guideline"}},{"kind":"Field","alias":{"kind":"Name","value":"guaranteedAnalysis"},"name":{"kind":"Name","value":"guaranteed_analysis"}},{"kind":"Field","name":{"kind":"Name","value":"ingredients"}},{"kind":"Field","name":{"kind":"Name","value":"ressources"}},{"kind":"Field","name":{"kind":"Name","value":"claims"}},{"kind":"Field","alias":{"kind":"Name","value":"buyCta"},"name":{"kind":"Name","value":"buy_cta"}},{"kind":"Field","alias":{"kind":"Name","value":"renCta"},"name":{"kind":"Name","value":"buy_cta_rens"}},{"kind":"Field","name":{"kind":"Name","value":"specifications"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SeoContent"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"colorScheme"},"name":{"kind":"Name","value":"color_scheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"accent"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product_type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"animals"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"animalId"}}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"facet_options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"product_facets_item_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"frTranslations"},"name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"fr-FR","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"flavor"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"flavor"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"flavorIcon"},"name":{"kind":"Name","value":"flavor_icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"animals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"claims"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"claimsId"},"name":{"kind":"Name","value":"claims_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"icon"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recommendations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"recommendedProducts"},"name":{"kind":"Name","value":"recommended_products"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"productsId"},"name":{"kind":"Name","value":"products_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"typename"},"name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"colors"},"name":{"kind":"Name","value":"color_scheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"featuredImage"},"name":{"kind":"Name","value":"featured_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"animals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"facetOptions"},"name":{"kind":"Name","value":"facet_options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"productFacetsItemId"},"name":{"kind":"Name","value":"product_facets_item_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SeoContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"seo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<ProductQuery, ProductQueryVariables>;
export const ProductsArchivePageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"productsArchivePage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"friendly_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"products-archive","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"colorScheme"},"name":{"kind":"Name","value":"color_scheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"accent"}},{"kind":"Field","name":{"kind":"Name","value":"background"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SeoContent"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SeoContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"seo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<ProductsArchivePageQuery, ProductsArchivePageQueryVariables>;
export const ProductsSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductsSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"productsTranslations"},"name":{"kind":"Name","value":"products_translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"title"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"product"},"name":{"kind":"Name","value":"products_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"colors"},"name":{"kind":"Name","value":"color_scheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"background"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"featuredImage"},"name":{"kind":"Name","value":"featured_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"animals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProductsSearchQuery, ProductsSearchQueryVariables>;
export const SettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"settings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"storeRocketAccountId"},"name":{"kind":"Name","value":"storerocket_account_id"}},{"kind":"Field","alias":{"kind":"Name","value":"storeRocketEnabledFilters"},"name":{"kind":"Name","value":"storerocket_enabled_filters"}},{"kind":"Field","alias":{"kind":"Name","value":"storeRocketFilters"},"name":{"kind":"Name","value":"storerocket_filters"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"facebookLink"},"name":{"kind":"Name","value":"facebook_link"}},{"kind":"Field","alias":{"kind":"Name","value":"instagramLink"},"name":{"kind":"Name","value":"instagram_link"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","alias":{"kind":"Name","value":"privacyPolicy"},"name":{"kind":"Name","value":"privacy_policy"}},{"kind":"Field","alias":{"kind":"Name","value":"termsAndCondition"},"name":{"kind":"Name","value":"terms_and_conditions"}},{"kind":"Field","alias":{"kind":"Name","value":"buyCta"},"name":{"kind":"Name","value":"buy_cta"}},{"kind":"Field","alias":{"kind":"Name","value":"renCta"},"name":{"kind":"Name","value":"renspet_cta"}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SeoContent"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mondou_logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"renspet_logo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SeoContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"seo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<SettingsQuery, SettingsQueryVariables>;
export const SinglePageSlugInOtherLanguageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SinglePageSlugInOtherLanguage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uri"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"translations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uri"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<SinglePageSlugInOtherLanguageQuery, SinglePageSlugInOtherLanguageQueryVariables>;
export const SinglePageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SinglePage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uri"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"translations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uri"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"friendlyId"},"name":{"kind":"Name","value":"friendly_id"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"colorScheme"},"name":{"kind":"Name","value":"color_scheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"frTranslations"},"name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"fr-FR","block":false}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageSections"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageSections"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SeoContent"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ColorScheme"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"color_schemes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"accent"}},{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"outline"}},{"kind":"Field","alias":{"kind":"Name","value":"backgroundMuted"},"name":{"kind":"Name","value":"background_muted"}},{"kind":"Field","alias":{"kind":"Name","value":"accentMuted"},"name":{"kind":"Name","value":"accent_muted"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockFaq"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_faq"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"qnaList"},"name":{"kind":"Name","value":"qna_list"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockMdx"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_mdx"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockStories"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_stories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"storiesId"},"name":{"kind":"Name","value":"stories_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"backgroundColor"},"name":{"kind":"Name","value":"background_color"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"footnote"}},{"kind":"Field","alias":{"kind":"Name","value":"petName"},"name":{"kind":"Name","value":"pet_name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockContest"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_contest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}},{"kind":"Field","name":{"kind":"Name","value":"featured_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageSections"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pages_translations_sections"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"Field","alias":{"kind":"Name","value":"friendlyId"},"name":{"kind":"Name","value":"friendly_id"}},{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockContent"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_faq"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockFaq"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_mdx"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"friendlyId"},"name":{"kind":"Name","value":"friendly_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockMdx"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_stories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"Field","alias":{"kind":"Name","value":"friendlyId"},"name":{"kind":"Name","value":"friendly_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockStories"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_contest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"Field","alias":{"kind":"Name","value":"friendlyId"},"name":{"kind":"Name","value":"friendly_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockContest"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SeoContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"seo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<SinglePageQuery, SinglePageQueryVariables>;
export const PagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Pages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"animals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date_updated"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"languages_code"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"friendly_title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"9999"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"published","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date_updated"}},{"kind":"Field","name":{"kind":"Name","value":"animals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"languages_code"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"friendly_title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"languages_code"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"articles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"9999"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"published","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date_updated"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"languages_code"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"9999"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"published","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"translations"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"slug"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_nin"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"home","block":false}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date_updated"}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"languages_code"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<PagesQuery, PagesQueryVariables>;
export const WhereToFindUsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WhereToFindUs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"friendly_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"StringValue","value":"find-us","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"translations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages_code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageSections"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SeoContent"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"colorScheme"},"name":{"kind":"Name","value":"color_scheme"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ColorScheme"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"color_schemes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"accent"}},{"kind":"Field","name":{"kind":"Name","value":"background"}},{"kind":"Field","name":{"kind":"Name","value":"outline"}},{"kind":"Field","alias":{"kind":"Name","value":"backgroundMuted"},"name":{"kind":"Name","value":"background_muted"}},{"kind":"Field","alias":{"kind":"Name","value":"accentMuted"},"name":{"kind":"Name","value":"accent_muted"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockFaq"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_faq"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"qnaList"},"name":{"kind":"Name","value":"qna_list"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockMdx"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_mdx"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockStories"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_stories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"storiesId"},"name":{"kind":"Name","value":"stories_id"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"backgroundColor"},"name":{"kind":"Name","value":"background_color"}},{"kind":"Field","name":{"kind":"Name","value":"picture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"footnote"}},{"kind":"Field","alias":{"kind":"Name","value":"petName"},"name":{"kind":"Name","value":"pet_name"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockContest"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_contest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"colors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ColorScheme"}}]}},{"kind":"Field","name":{"kind":"Name","value":"featured_image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"filenameDownload"},"name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageSections"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"pages_translations_sections"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_content"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"Field","alias":{"kind":"Name","value":"friendlyId"},"name":{"kind":"Name","value":"friendly_id"}},{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockContent"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_faq"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockFaq"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_mdx"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"Field","alias":{"kind":"Name","value":"title"},"name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"friendlyId"},"name":{"kind":"Name","value":"friendly_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockMdx"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_stories"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"Field","alias":{"kind":"Name","value":"friendlyId"},"name":{"kind":"Name","value":"friendly_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockStories"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"block_contest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"isAnchored"},"name":{"kind":"Name","value":"is_anchored"}},{"kind":"Field","alias":{"kind":"Name","value":"shortTitle"},"name":{"kind":"Name","value":"short_title"}},{"kind":"Field","alias":{"kind":"Name","value":"friendlyId"},"name":{"kind":"Name","value":"friendly_id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockContest"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SeoContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"seo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"filename_download"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<WhereToFindUsQuery, WhereToFindUsQueryVariables>;